/* Blood View Booking — single-page multi-step flow engine */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__bvbInit) return;
    root.__bvbInit = true;

    var cfgEl = root.querySelector('[data-bvb-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    var S = cfg.settings || {};

    // Questions come from the theme editor as a FLAT list of groups (one per block).
    // Consecutive groups that share an "eyebrow" are merged into a single step.
    var QUESTIONS = (function () {
      var flat = cfg.groups || cfg.questions || [];
      // Back-compat: if an already-nested questions array is supplied, use it as-is.
      if (flat.length && flat[0] && flat[0].groups) return flat;
      var steps = [], cur = null;
      flat.forEach(function (g) {
        if (!g || !g.key) return;
        if (!cur || cur.eyebrow !== g.eyebrow) {
          cur = { key: g.key, eyebrow: g.eyebrow, title1: g.title1, title2: g.title2, groups: [] };
          steps.push(cur);
        }
        cur.groups.push(g);
      });
      return steps;
    })();
    var MAX_BYTES = (S.maxMb || 10) * 1024 * 1024;
    var MAX_UPLOADS = S.maxUploads || 3;
    var STORE_KEY = S.storageKey || 'bvb_journey_v1';
    var USER_KEY = S.userKey || 'bvb_user_id'; // customerId key — scoped per journey below
    var HOME_URL = S.homeUrl || '/';

    // Native shell bridge: leaving the flow inside the app should pop the native screen
    // instead of navigating the WebView. Detected via the bridge object rather than
    // ?app=true, because that param is dropped as soon as the user navigates in from the
    // landing page. Callers still run their normal navigation afterwards, so behaviour is
    // unchanged on the web and when the app has no matching onMessage handler.
    function postAppBack() {
      var rn = window.ReactNativeWebView;
      if (!rn || typeof rn.postMessage !== 'function') return false;
      try { rn.postMessage(JSON.stringify({ type: 'wbn_app_back' })); return true; }
      catch (e) { return false; }
    }

    // Server ids are 15-char alphanumeric, mixed case (e.g. "mxbi0wOJhFD6OLt"); accept a
    // generous alphanumeric range so a stored server id survives a reload.
    function isValidId(id) { return typeof id === 'string' && /^[A-Za-z0-9]{8,64}$/.test(id); }
    function persistUserId(id) { try { localStorage.setItem(USER_KEY, id); } catch (e) {} }
    function getStoredUserId() {
      try { var id = localStorage.getItem(USER_KEY); return isValidId(id) ? id : ''; } catch (e) { return ''; }
    }
    // The customerId is minted per journey by the backend (startJourney) or supplied via
    // the reschedule URL param — never generated client-side. Resolved once the journey is
    // known, since USER_KEY is journey-scoped (see below).
    var storedUserId = '';
    var USER_ID = '';

    var qHost = root.querySelector('[data-bvb-questions]');
    var stepEls = [];               // ordered navigable steps (upload .. review)
    var uploadEl = root.querySelector('[data-step="upload"]');
    var reviewEl = root.querySelector('[data-step="review"]');
    var confirmEl = root.querySelector('[data-step="confirmation"]');

    // Which journey was launched, read from ?journey= ("upload" default, or "book").
    var journey = 'upload';
    try {
      var qp = (location.search || '').match(/[?&]journey=([^&#]+)/);
      if (qp) journey = decodeURIComponent(qp[1]) === 'book' ? 'book' : 'upload';
    } catch (e) {}
    root.setAttribute('data-journey', journey);

    // ---- CleverTap: flow_milestone_completed ----
    // Reads a UTM param from the current URL (case-insensitive); '' when absent.
    function bvbUtmParam(name) {
      try {
        var m = (location.search || '').match(new RegExp('[?&]' + name + '=([^&#]+)', 'i'));
        return m ? decodeURIComponent(m[1]) : '';
      } catch (e) { return ''; }
    }
    // Fires once per milestone: 'pdf_uploaded' | 'questions_submitted' | 'slot_booked'.
    function trackMilestone(milestone) {
      var payload = {
        flow_type: journey === 'book' ? 'booking' : 'upload',
        milestone_reached: milestone,
        utm_source: bvbUtmParam('utm_source') || 'organic',
        utm_campaign: bvbUtmParam('utm_campaign') || null,
        utm_medium: bvbUtmParam('utm_medium') || null,
        utm_term: bvbUtmParam('utm_term') || null
      };
      if (typeof clevertap === 'undefined' || !clevertap.event || typeof clevertap.event.push !== 'function') return;
      clevertap.event.push('flow_milestone_completed', payload);
    }
    // Fires once when the "Maximum Uploads Done" screen is shown (upload journey).
    var pdfExhaustedTracked = false;
    function trackPdfExhausted() {
      if (pdfExhaustedTracked) return;
      pdfExhaustedTracked = true;
      var payload = {
        old_customer_id: USER_ID || '',
        attempted_upload_count: state.uploadAttempts || MAX_UPLOADS,
        flow_type: 'upload'
      };
      if (typeof clevertap === 'undefined' || !clevertap.event || typeof clevertap.event.push !== 'function') return;
      clevertap.event.push('pdf_exhausted_tries', payload);
    }
    // Fires when the user abandons the flow via the leave modal's "Back to Shopping".
    function trackJourneyDropOff() {
      var payload = {
        customer_id: USER_ID || '',
        flow_type: journey === 'book' ? 'booking' : 'upload',
        drop_off_step: state.step,
        utm_source: bvbUtmParam('utm_source') || 'organic',
        utm_campaign: bvbUtmParam('utm_campaign') || null,
        utm_medium: bvbUtmParam('utm_medium') || null,
        utm_term: bvbUtmParam('utm_term') || null
      };
      if (typeof clevertap === 'undefined' || !clevertap.event || typeof clevertap.event.push !== 'function') return;
      clevertap.event.push('journey_drop_off', payload);
    }

    // Isolate saved progress per journey so upload/book don't clobber each other.
    STORE_KEY = STORE_KEY + '_' + journey;
    // Each journey gets its OWN customerId — the upload id must NOT be reused for book.
    USER_KEY = USER_KEY + '_' + journey;
    storedUserId = getStoredUserId();
    USER_ID = storedUserId || '';

    var state = {
      step: 0,
      answers: {},
      bookingFor: 'myself',
      journey: journey,
      file: null,
      fileMeta: null,
      uploadAttempts: 0,
      reportUrl: '',          // S3 url returned by the upload API on a valid report
      uploadValidated: false, // true once the current file passed the upload API
      phone: '',              // optional; not collected by the current questionnaire UI
      questionnaireSubmitted: false, // true once answers were accepted by the API
      bookingConfirmed: false, // true once booking/confirm accepted the slot
      resoluteOrderId: null,   // returned by booking/confirm (null while stubbed)
      slot: { flat: '', landmark: '', email: '', address: '', city: '', pincode: '', state: '', date: '', time: '' }
    };

    /* ---------- helpers ---------- */
    function el(tag, cls, attrs) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
      return n;
    }
    function txt(tag, cls, text) { var n = el(tag, cls); n.textContent = text; return n; }
    function fmtBytes(b) {
      if (b == null) return '';
      if (b >= 1024 * 1024) return (Math.round((b / 1048576) * 10) / 10) + ' MB';
      if (b >= 1024) return Math.round(b / 1024) + ' KB';
      return b + ' B';
    }

    function heading(t1, t2) {
      var h = el('div', 'bvb-heading');
      h.appendChild(txt('p', 'bvb-heading__1', t1));
      if (t2) h.appendChild(txt('p', 'bvb-heading__2', t2));
      return h;
    }
    function footer(stepIndex) {
      var f = el('div', 'bvb-footer');
      var acts = el('div', 'bvb-footer__actions');
      var back = txt('button', 'bvb-btn bvb-btn--secondary', S.backLabel || 'Back');
      back.type = 'button'; back.setAttribute('data-bvb-prev', '');
      var next = txt('button', 'bvb-btn bvb-btn--primary', S.continueLabel || 'Continue');
      next.type = 'button'; next.setAttribute('data-bvb-next', '');
      acts.appendChild(back); acts.appendChild(next);
      f.appendChild(acts);
      return f;
    }

    /* ---------- build question steps ---------- */
    function buildQuestion(q) {
      var step = el('div', 'page-bvb__step', { 'data-step': 'q-' + q.key });
      step.appendChild(heading(q.title1 || 'Few questions', q.title2 || 'about you'));
      if (q.eyebrow) step.appendChild(txt('p', 'bvb-eyebrow', q.eyebrow + ' :'));

      var cover = el('div', 'bvb-cover');
      (q.groups || []).forEach(function (g) {
        var grp = el('div', 'bvb-group', { 'data-group': g.key });
        grp.appendChild(txt('p', 'bvb-group__label', g.label));

        if (g.type === 'text' || g.type === 'number') {
          var input = el('input', 'bvb-input', {
            type: 'text',
            placeholder: g.placeholder || '',
            'data-field': g.key,
            autocomplete: g.autocomplete || 'off'
          });
          if (g.type === 'number') { input.setAttribute('inputmode', 'numeric'); input.setAttribute('data-numeric', ''); }
          if ((g.autocomplete || '') === 'name') input.setAttribute('data-name', '');
          if ((g.autocomplete || '') === 'tel') { input.setAttribute('type', 'tel'); input.setAttribute('inputmode', 'numeric'); input.setAttribute('data-tel', ''); }
          if ((g.autocomplete || '') === 'email') { input.setAttribute('type', 'email'); input.setAttribute('inputmode', 'email'); input.setAttribute('data-email', ''); }
          grp.appendChild(input);
        } else {
          var chips = el('div', 'bvb-chips', { role: g.type === 'multi' ? 'group' : 'radiogroup', 'data-chips': g.key });
          if (g.type === 'multi') chips.setAttribute('data-multi', '');
          if (g.max) chips.setAttribute('data-max', g.max);
          (g.options || []).forEach(function (opt) {
            var c = txt('button', 'bvb-chip', opt);
            c.type = 'button';
            c.setAttribute('data-option', opt);
            if (g.noneOption && opt === g.noneOption) c.setAttribute('data-none', '');
            chips.appendChild(c);
          });
          grp.appendChild(chips);
        }
        var err = txt('p', 'bvb-error', '');
        err.setAttribute('data-error', g.key);
        err.style.display = 'none';
        grp.appendChild(err);
        cover.appendChild(grp);
      });
      step.appendChild(cover);

      step.appendChild(footer());
      return step;
    }

    // Build the question steps once.
    var questionEls = QUESTIONS.map(function (q) {
      var node = buildQuestion(q);
      qHost.appendChild(node);
      return node;
    });
    // Continue on this step submits the questionnaire before advancing.
    var lastQuestionEl = questionEls.length ? questionEls[questionEls.length - 1] : null;
    var slotEl = root.querySelector('[data-step="slot"]');

    // Assemble the ordered step list per journey:
    //  - upload:  upload  -> questions -> review
    //  - book:    questions -> slot -> review   (no upload step)
    if (journey === 'book') {
      stepEls = questionEls.concat(slotEl ? [slotEl] : [], [reviewEl]);
    } else {
      stepEls = [uploadEl].concat(questionEls, [reviewEl]);
    }
    var TOTAL = stepEls.length; // always 10

    // Reschedule deep-link entry (PRD Epic 7):
    // /pages/blood-view-booking?reshedule=true&customerId=...  → jump straight to the
    // slot/schedule step in reschedule mode. Only the slot is editable — no questions,
    // upload, review or re-payment.
    var IS_RESCHEDULE = /[?&](?:reschedule|reshedule)=true\b/i.test(location.search || '');
    if (IS_RESCHEDULE && slotEl) {
      state.isReschedule = true;
      var rcid = (location.search || '').match(/[?&]customerId=([^&#]+)/i);
      if (rcid) {
        USER_ID = decodeURIComponent(rcid[1]);
        try { localStorage.setItem(USER_KEY, USER_ID); } catch (e) {}
      }
      stepEls = [slotEl];        // reschedule shows ONLY the slot step
      TOTAL = stepEls.length;
    }

    /* ---------- customerId: mint from backend ---------- */
    // Mints a fresh customerId via journey/start and stores it. Used on a genuine first
    // start and on "Restart your journey". On failure we retry a couple of times; the id
    // is never generated client-side.
    function mintCustomerId() {
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      if (!base) return;             // no endpoint configured → leave USER_ID empty
      var flowType = journey === 'book' ? 'booking' : 'upload';
      var attempt = 0, MAX = 3;      // initial try + 2 retries
      (function go() {
        attempt++;
        fetch(base + '/api/v2/bloodview/journey/start', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ flowType: flowType })
        })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (res) {
          var cid = res && res.data && res.data.customerId;
          if (!isValidId(cid)) throw new Error('bad customerId');
          USER_ID = cid; storedUserId = cid;
          persistUserId(cid);
        })
        .catch(function () { if (attempt < MAX) setTimeout(go, 400 * attempt); });
      })();
    }
    // First start: skip on reschedule (id from URL) and on resume (stored id reused).
    if (!IS_RESCHEDULE && !storedUserId) mintCustomerId();

    /* ---------- progress bar (questionnaire steps only) ---------- */
    var progressEl = root.querySelector('[data-bvb-progress]');
    var progressFill = root.querySelector('[data-bvb-progress-fill]');
    var progressPct = root.querySelector('[data-bvb-progress-pct]');
    // Weighted progress: first 3 questions are worth 15% each (45% total), the rest 11% each.
    // The bar shows the weight accumulated by the questions already completed — so the FIRST
    // question reads 0%, and it climbs by each completed question's weight (e.g. on Q4 = 45%).
    function questionWeight(idx) { return idx < 3 ? 15 : 11; }
    function updateProgress(i) {
      if (!progressEl) return;
      var qi = IS_RESCHEDULE ? -1 : questionEls.indexOf(stepEls[i]);
      var onQuestion = qi !== -1;
      progressEl.hidden = !onQuestion;
      if (!onQuestion) return;
      var pct = 0;
      for (var q = 0; q < qi; q++) pct += questionWeight(q); // sum weights of completed questions
      pct = Math.max(0, Math.min(100, Math.round(pct)));
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressPct) progressPct.textContent = pct + '%';
      progressEl.setAttribute('aria-valuenow', String(pct));
    }
    function hideProgress() { if (progressEl) progressEl.hidden = true; }

    /* ---------- navigation ---------- */
    function showStep(i, skipSave) {
      i = Math.max(0, Math.min(TOTAL - 1, i));
      state.step = i;
      stepEls.forEach(function (n, idx) { n.classList.toggle('is-active', idx === i); });
      applyConcernLock(stepEls[i]);
      updateProgress(i);
      if (confirmEl) confirmEl.classList.remove('is-active');
      if (i === TOTAL - 1) renderReview();
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
      if (!skipSave) save();
      var focusable = stepEls[i].querySelector('input, .bvb-chip, .bvb-btn');
      if (focusable && i !== 0) { try { focusable.focus({ preventScroll: true }); } catch (e) {} }
    }
    function next() {
      var node = stepEls[state.step];
      if (node === uploadEl) { goAfterUpload(); return; }
      if (node === slotEl) {
        if (!validateSlot()) return;
        // Verify city/state actually belong to the pincode (India Post) before proceeding.
        var proceed = function () {
          if (state.isReschedule) { rescheduleSubmit(); return; }
          // Book journey → confirm the slot with the API, then advance on success.
          if (!state.bookingConfirmed) { submitBooking(); return; }
          showStep(state.step + 1);
        };
        (slotEl.__verifyLocation ? slotEl.__verifyLocation() : Promise.resolve(true))
          .then(function (ok) { if (ok) proceed(); }); // mismatch → error already shown, stay put
        return;
      }
      if (!validateStep(node)) return;
      // Last questionnaire step → submit answers to the API, then advance on success.
      if (node === lastQuestionEl && !state.questionnaireSubmitted) { submitQuestionnaire(); return; }
      if (state.step === TOTAL - 1) { submit(); return; }
      showStep(state.step + 1);
    }
    function prev() {
      // Reschedule entered from the confirmation → Back returns to the confirmation.
      if (state.rescheduleFromConfirm && stepEls[state.step] === slotEl) {
        exitReschedule();
        if (lastJourney) showPaidConfirmation(lastJourney);
        return;
      }
      // First step → there is no earlier step, so Back leaves the flow via the same
      // guard as the X control: warn when there's progress to lose, otherwise exit.
      if (state.step === 0) { maybeLeave(); return; }
      showStep(state.step - 1);
    }

    /* ---------- questionnaire submission ---------- */
    // Fallback map for the standard q_* blocks; an explicit block "apiKey" wins.
    var API_KEY_MAP = {
      q_name: 'name', q_age: 'age', q_gender: 'gender', q_diet: 'diet', q_goal: 'goal',
      q_concern_primary: 'primaryHealthConcern', q_concern_secondary: 'secondaryHealthConcern',
      q_medical: 'medicalcondition', q_skin: 'primarySkinHairNailConcern',
      q_gut: 'primaryGutConcern', q_alcohol: 'drink', q_smoke: 'smoke'
    };
    function apiKeyFor(g) { return (g.apiKey && String(g.apiKey).trim()) || API_KEY_MAP[g.key] || ''; }
    function buildAnswersPayload() {
      var out = {};
      QUESTIONS.forEach(function (q) {
        (q.groups || []).forEach(function (g) {
          var ak = apiKeyFor(g);
          if (!ak) return;
          var v = state.answers[g.key];
          if (v == null || v === '' || (Array.isArray(v) && !v.length)) return;
          out[ak] = v;   // arrays (multi-select) are sent as-is
        });
      });
      return out;
    }
    // Inline error + busy state live on the last questionnaire step's footer/Continue.
    function qErr(msg) {
      if (!lastQuestionEl) return;
      var e = lastQuestionEl.querySelector('[data-bvb-q-error]');
      if (!e) {
        e = el('p', 'bvb-error', { 'data-bvb-q-error': '', role: 'alert' });
        var f = lastQuestionEl.querySelector('.bvb-footer');
        if (f) lastQuestionEl.insertBefore(e, f); else lastQuestionEl.appendChild(e);
      }
      e.textContent = msg || ''; e.style.display = msg ? 'block' : 'none';
    }
    function setQBusy(busy) {
      if (!lastQuestionEl) return;
      var btn = lastQuestionEl.querySelector('[data-bvb-next]');
      if (!btn) return;
      if (busy) {
        btn.disabled = true;
        if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
        btn.textContent = S.questionnaireBusyLabel || 'Saving…';
      } else {
        btn.disabled = false;
        var l = btn.getAttribute('data-label'); if (l) btn.textContent = l;
      }
    }
    function submitQuestionnaire() {
      var fromStep = state.step;
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      // No endpoint or customerId → keep the legacy behaviour (don't block the flow).
      if (!base || !USER_ID) { state.questionnaireSubmitted = true; trackMilestone('questions_submitted'); showStep(fromStep + 1); return; }
      setQBusy(true); qErr('');
      fetch(base + '/api/v2/bloodview/questionnaire', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: USER_ID, phone: state.phone || '', answers: buildAnswersPayload() })
      })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (res) {
        setQBusy(false);
        if (!(res && res.data && res.data.ok)) throw new Error('not ok');
        state.questionnaireSubmitted = true;
        trackMilestone('questions_submitted');
        save();
        showStep(fromStep + 1);
      })
      .catch(function () { setQBusy(false); qErr('We couldn’t save your answers. Please try again.'); });
    }

    /* ---------- booking confirm (Book journey slot step) ---------- */
    function bookingErr(msg) {
      if (!slotEl) return;
      var e = slotEl.querySelector('[data-bvb-booking-error]');
      if (!e) {
        e = el('p', 'bvb-error', { 'data-bvb-booking-error': '', role: 'alert' });
        var f = slotEl.querySelector('.bvb-footer');
        if (f) slotEl.insertBefore(e, f); else slotEl.appendChild(e);
      }
      e.textContent = msg || ''; e.style.display = msg ? 'block' : 'none';
    }
    function setBookingBusy(busy) {
      var btn = slotEl ? slotEl.querySelector('[data-bvb-next]') : null;
      if (!btn) return;
      if (busy) {
        btn.disabled = true;
        if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
        btn.textContent = S.bookingBusyLabel || 'Confirming…';
      } else {
        btn.disabled = false;
        var l = btn.getAttribute('data-label'); if (l) btn.textContent = l;
      }
    }
    function submitBooking() {
      var fromStep = state.step;
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      // No endpoint or customerId → keep the legacy behaviour (don't block the flow).
      if (!base || !USER_ID) { state.bookingConfirmed = true; trackMilestone('slot_booked'); showStep(fromStep + 1); return; }
      setBookingBusy(true); bookingErr('');
      fetch(base + '/api/v2/bloodview/booking/confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: USER_ID,
          flat: state.slot.flat || '',
          landmark: state.slot.landmark || '',
          email: state.slot.email || '',
          address: state.slot.address || '',
          city: state.slot.city || '',
          state: state.slot.state || '',
          pincode: state.slot.pincode || '',
          date: state.slot.date || '',
          time: state.slot.time || ''
        })
      })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (res) {
        setBookingBusy(false);
        if (!(res && res.status === 'success')) throw new Error('not ok');
        state.bookingConfirmed = true;
        if (res.data && res.data.resoluteOrderId) state.resoluteOrderId = res.data.resoluteOrderId;
        trackMilestone('slot_booked');
        save();
        showStep(fromStep + 1);
      })
      .catch(function () { setBookingBusy(false); bookingErr('We couldn’t confirm your booking. Please try again.'); });
    }

    /* ---------- answers & validation ---------- */
    function getGroupConfig(stepKey, groupKey) {
      var q = QUESTIONS.filter(function (x) { return 'q-' + x.key === stepKey; })[0];
      if (!q) return null;
      return (q.groups || []).filter(function (g) { return g.key === groupKey; })[0] || null;
    }
    function showGroupError(node, key, msg) {
      var e = node.querySelector('[data-error="' + key + '"]');
      if (e) { e.textContent = msg || ''; e.style.display = msg ? 'block' : 'none'; }
    }
    function validateStep(node) {
      var ok = true;
      var stepKey = node.getAttribute('data-step');
      var groups = node.querySelectorAll('[data-group]');
      Array.prototype.forEach.call(groups, function (grp) {
        var key = grp.getAttribute('data-group');
        var g = getGroupConfig(stepKey, key) || {};
        var msg = g.requiredMsg || 'This field is required';
        var val = state.answers[key];
        var bad = false;
        if (g.type === 'text' || g.type === 'number') {
          bad = !val || !String(val).trim();
          if (!bad && g.type === 'number' && (isNaN(parseInt(val, 10)) || parseInt(val, 10) <= 0)) {
            bad = true; msg = 'Please enter a valid number';
          }
          if (!bad && g.type === 'number' && apiKeyFor(g) === 'age') {
            var age = parseInt(val, 10);
            if (isNaN(age) || age < 16 || age > 105) { bad = true; msg = 'Please enter an age between 16 and 105'; }
          }
          if (!bad && (g.autocomplete || '') === 'name') {
            var nm = String(val).trim();
            if (nm.length < 2 || !/\p{L}/u.test(nm) || !/^[\p{L} .'-]+$/u.test(nm)) {
              bad = true; msg = 'Please enter a valid name';
            }
          }
          if (!bad && apiKeyFor(g) === 'phone') {
            if (!/^[6-9]\d{9}$/.test(String(val).trim())) { bad = true; msg = 'Please enter a valid 10-digit phone number'; }
          }
          if (!bad && apiKeyFor(g) === 'email') {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(val).trim())) { bad = true; msg = 'Please enter a valid email'; }
          }
        } else if (g.type === 'multi') {
          bad = !val || !val.length;
        } else {
          bad = !val;
        }
        if (bad && g.required !== false) { showGroupError(node, key, msg); ok = false; }
        else { showGroupError(node, key, ''); }
      });
      return ok;
    }

    // delegated input + chip handling
    qHost.addEventListener('input', function (e) {
      var input = e.target.closest('.bvb-input');
      if (!input) return;
      var key = input.getAttribute('data-field');
      if (input.hasAttribute('data-numeric')) {
        input.value = input.value.replace(/[^0-9]/g, '').slice(0, 3);
      } else if (input.hasAttribute('data-tel')) {
        input.value = input.value.replace(/[^0-9]/g, '').slice(0, 10);
      } else if (input.hasAttribute('data-name')) {
        // Names: letters (any script), spaces, and . ' - only.
        input.value = input.value.replace(/[^\p{L} .'-]/gu, '');
      }
      state.answers[key] = input.value;
      if (input.hasAttribute('data-tel')) state.phone = input.value; // feed the questionnaire API
      state.questionnaireSubmitted = false; // answers changed → must re-submit
      var node = input.closest('.page-bvb__step');
      showGroupError(node, key, '');
      save();
    });
    // Primary/Secondary health concern are mutually exclusive: the option chosen in one
    // group is disabled (and cleared if already picked) in the other.
    function concernApiKey(node, chipsEl) {
      var g = getGroupConfig(node.getAttribute('data-step'), chipsEl.getAttribute('data-chips'));
      return g ? apiKeyFor(g) : '';
    }
    function lockConcernPair(srcKey, targetChips, targetKey) {
      var selected = state.answers[srcKey];
      var hasSel = selected != null && selected !== '';
      Array.prototype.forEach.call(targetChips.querySelectorAll('.bvb-chip'), function (c) {
        if (hasSel && c.getAttribute('data-option') === selected) {
          if (c.classList.contains('is-selected')) { c.classList.remove('is-selected'); state.answers[targetKey] = ''; }
          c.classList.add('is-disabled'); c.setAttribute('aria-disabled', 'true');
        } else {
          c.classList.remove('is-disabled'); c.removeAttribute('aria-disabled');
        }
      });
    }
    function applyConcernLock(node) {
      if (!node) return;
      var primary = null, secondary = null;
      Array.prototype.forEach.call(node.querySelectorAll('[data-chips]'), function (c) {
        var ak = concernApiKey(node, c);
        if (ak === 'primaryHealthConcern') primary = c;
        else if (ak === 'secondaryHealthConcern') secondary = c;
      });
      if (!primary || !secondary) return;
      lockConcernPair(primary.getAttribute('data-chips'), secondary, secondary.getAttribute('data-chips'));
      lockConcernPair(secondary.getAttribute('data-chips'), primary, primary.getAttribute('data-chips'));
    }

    qHost.addEventListener('click', function (e) {
      var chip = e.target.closest('.bvb-chip');
      if (!chip) return;
      if (chip.classList.contains('is-disabled')) return; // locked by the paired concern group
      var chips = chip.closest('[data-chips]');
      var key = chips.getAttribute('data-chips');
      var node = chip.closest('.page-bvb__step');
      var opt = chip.getAttribute('data-option');

      if (chips.hasAttribute('data-multi')) {
        var arr = state.answers[key] || [];
        var isNone = chip.hasAttribute('data-none');
        if (isNone) {
          // None is exclusive
          var sel = chip.classList.toggle('is-selected');
          Array.prototype.forEach.call(chips.querySelectorAll('.bvb-chip'), function (c) {
            if (c !== chip) c.classList.remove('is-selected');
          });
          arr = sel ? [opt] : [];
        } else {
          var noneChip = chips.querySelector('[data-none]');
          if (noneChip) noneChip.classList.remove('is-selected');
          arr = (state.answers[key] || []).filter(function (v) { return v !== (noneChip && noneChip.getAttribute('data-option')); });
          var idx = arr.indexOf(opt);
          var max = parseInt(chips.getAttribute('data-max') || '0', 10);
          if (idx >= 0) { arr.splice(idx, 1); chip.classList.remove('is-selected'); }
          else {
            if (max && arr.length >= max) {
              // replace oldest selection to respect max
              var first = arr.shift();
              var firstChip = chips.querySelector('[data-option="' + cssEsc(first) + '"]');
              if (firstChip) firstChip.classList.remove('is-selected');
            }
            arr.push(opt); chip.classList.add('is-selected');
          }
        }
        state.answers[key] = arr;
      } else {
        // single
        Array.prototype.forEach.call(chips.querySelectorAll('.bvb-chip'), function (c) { c.classList.remove('is-selected'); });
        chip.classList.add('is-selected');
        state.answers[key] = opt;
      }
      applyConcernLock(node); // sync the mutually-exclusive concern groups
      state.questionnaireSubmitted = false; // answers changed → must re-submit
      showGroupError(node, key, '');
      save();
    });
    function cssEsc(v) { return String(v).replace(/"/g, '\\"'); }

    // footer nav (delegated across the whole root)
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-bvb-next]')) { e.preventDefault(); next(); }
      else if (e.target.closest('[data-bvb-prev]')) { e.preventDefault(); prev(); }
    });

    /* ---------- upload step ---------- */
    var dz = uploadEl.querySelector('[data-bvb-dropzone]');
    var fileInput = uploadEl.querySelector('[data-bvb-file]');
    var viewEmpty = uploadEl.querySelector('[data-bvb-upload-empty]');
    var viewUploaded = uploadEl.querySelector('[data-bvb-upload-done]');
    var viewMax = uploadEl.querySelector('[data-bvb-upload-max]');
    var fnameEl = uploadEl.querySelector('[data-bvb-up-name]');
    var fmetaEl = uploadEl.querySelector('[data-bvb-up-meta]');
    // One error node lives in each upload view (empty + done); write to all so the error
    // appears below whichever view's action buttons are currently visible.
    var upErrorEls = uploadEl.querySelectorAll('[data-bvb-up-error]');

    function setUploadView(v) {
      if (viewEmpty) viewEmpty.style.display = v === 'empty' ? '' : 'none';
      if (viewUploaded) viewUploaded.style.display = v === 'done' ? '' : 'none';
      if (viewMax) viewMax.style.display = v === 'max' ? '' : 'none';
    }
    function upErr(msg) {
      Array.prototype.forEach.call(upErrorEls, function (e) {
        e.textContent = msg || ''; e.style.display = msg ? 'block' : 'none';
      });
    }

    function isPdf(f) { return f && (f.type === 'application/pdf' || /\.pdf$/i.test(f.name || '')); }
    function validateFile(f) {
      if (!f) return 'Please select a file.';
      if (!isPdf(f)) return 'Please upload a PDF file.';
      if (f.size === 0) return 'This file appears to be empty. Please choose another.';
      if (f.size > MAX_BYTES) return 'File is larger than ' + (S.maxMb || 10) + ' MB. Please upload a smaller PDF.';
      return '';
    }
    // Clear the value first so re-selecting the SAME file still fires the change event.
    function openPicker() { if (fileInput) { fileInput.value = ''; fileInput.click(); } }

    function handlePicked(f) {
      var err = validateFile(f);
      if (err) { upErr(err); return; }
      upErr('');
      state.file = f;
      state.fileMeta = { name: f.name, size: f.size };
      state.uploadValidated = false;   // a new file must be re-validated by the API
      state.reportUrl = '';
      openConfirmUpload();
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var files = fileInput.files;
        if (!files || !files.length) return;
        if (files.length > 1) { upErr('Please upload a single PDF file.'); return; }
        handlePicked(files[0]);
      });
    }
    uploadEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-bvb-select]')) { e.preventDefault(); openPicker(); return; }
      if (e.target.closest('[data-bvb-reupload]')) { e.preventDefault(); tryReupload(); return; }
      if (e.target.closest('[data-bvb-upload-continue]')) { e.preventDefault(); goAfterUpload(); return; }
      if (e.target.closest('[data-bvb-restart]')) { e.preventDefault(); restartJourney(); return; }
    });
    // booking-for
    uploadEl.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bvb-bookingfor]');
      if (!t) return;
      Array.prototype.forEach.call(uploadEl.querySelectorAll('[data-bvb-bookingfor]'), function (b) {
        b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false');
      });
      t.classList.add('is-selected'); t.setAttribute('aria-checked', 'true');
      state.bookingFor = t.getAttribute('data-value');
      save();
    });

    // drag & drop on dropzone
    if (dz) {
      dz.addEventListener('click', function (e) {
        if (e.target.closest('.bvb-btn')) return;
        if (viewEmpty && viewEmpty.style.display !== 'none') openPicker();
      });
      var depth = 0;
      ['dragenter', 'dragover'].forEach(function (type) {
        dz.addEventListener(type, function (e) {
          if (viewMax && viewMax.style.display !== 'none') return;
          e.preventDefault(); e.dataTransfer.dropEffect = 'copy';
          if (type === 'dragenter') depth++;
          dz.classList.add('is-dragover');
        });
      });
      dz.addEventListener('dragleave', function () { depth = Math.max(0, depth - 1); if (!depth) dz.classList.remove('is-dragover'); });
      dz.addEventListener('drop', function (e) {
        e.preventDefault(); depth = 0; dz.classList.remove('is-dragover');
        if (viewMax && viewMax.style.display !== 'none') return;
        var dt = e.dataTransfer;
        if (!dt || !dt.files || !dt.files.length) return;
        if (dt.files.length > 1) { upErr('Please upload a single PDF file.'); return; }
        try {
          if (fileInput && window.DataTransfer) { var h = new DataTransfer(); h.items.add(dt.files[0]); fileInput.files = h.files; }
        } catch (err) {}
        handlePicked(dt.files[0]);
      });
    }
    // block accidental whole-page drop
    ['dragover', 'drop'].forEach(function (type) {
      root.addEventListener(type, function (e) { if (!e.target.closest('[data-bvb-dropzone]')) e.preventDefault(); });
    });

    function applyUploaded() {
      if (fnameEl) fnameEl.textContent = state.fileMeta ? state.fileMeta.name : '';
      if (fmetaEl) fmetaEl.textContent = state.fileMeta ? (fmtBytes(state.fileMeta.size) + ' · PDF') : '';
      setUploadView('done');
    }
    function tryReupload() {
      // re-pick counts as an attempt; enforce max
      if (state.uploadAttempts >= MAX_UPLOADS) { setUploadView('max'); trackPdfExhausted(); return; }
      openPicker();
    }
    function goAfterUpload() {
      if (!state.fileMeta) { upErr('Please select your report to continue.'); return; }
      if (state.uploadValidated) { showStep(1); return; }  // already validated this file
      uploadReport();
    }

    // POST the raw PDF bytes to the upload API; Resolute returns the validity verdict.
    function setContinueBusy(busy) {
      var btn = uploadEl.querySelector('[data-bvb-upload-continue]');
      if (!btn) return;
      if (busy) {
        btn.disabled = true;
        if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
        btn.textContent = S.uploadCheckingLabel || 'Checking…';
      } else {
        btn.disabled = false;
        var lbl = btn.getAttribute('data-label');
        if (lbl) btn.textContent = lbl;
      }
    }
    function handleUploadHttpError(status) {
      if (status === 413) { upErr('File is larger than ' + (S.maxMb || 10) + ' MB. Please upload a smaller PDF.'); return; }
      if (status === 400) { upErr('Please upload a valid PDF file.'); return; }
      if (status === 404 || status === 409) {   // journey expired / no longer active
        upErr('Your upload session has expired. Please start again.');
        setUploadView('max');
        return;
      }
      upErr('Something went wrong. Please try again.');
    }
    function uploadReport() {
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      // No endpoint or no customerId → keep the legacy behaviour (don't block the flow).
      if (!base || !USER_ID || !state.file) { state.uploadValidated = true; trackMilestone('pdf_uploaded'); showStep(1); return; }
      setContinueBusy(true);
      upErr('');
      fetch(base + '/api/v2/bloodview/upload?customerId=' + encodeURIComponent(USER_ID), {
        method: 'POST',
        headers: { 'Content-Type': 'application/pdf', 'X-File-Name': encodeURIComponent((state.fileMeta && state.fileMeta.name) || 'report.pdf') },
        body: state.file
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }, function () { return { ok: r.ok, status: r.status, body: null }; }); })
      .then(function (res) {
        setContinueBusy(false);
        // Any non-2xx is a real failure → surface the matching HTTP error.
        if (!res.ok) { handleUploadHttpError(res.status); return; }
        // API succeeded → accept the upload and advance, regardless of the validity verdict.
        var d = (res.body && res.body.data) || {};
        state.reportUrl = d.url || '';
        state.uploadValidated = true;
        trackMilestone('pdf_uploaded');
        save();
        showStep(1);
      })
      .catch(function () { setContinueBusy(false); upErr('Upload failed. Please check your connection and try again.'); });
    }
    function restartJourney() {
      // Fresh journey → drop saved progress + the old customerId, then go back to the
      // previous page (the BloodView landing the user came from).
      clearSaved();
      try { localStorage.removeItem(USER_KEY); } catch (e) {}
      // Navigate away directly (NOT history.back) so the browser-Back leave-guard can't
      // intercept the pop and show the "are you sure you want to leave?" modal. Prefer the
      // page the user came from; otherwise the BloodView landing.
      var dest = '/pages/wellbeing-bloodview';
      try {
        var ref = document.referrer ? new URL(document.referrer) : null;
        if (ref && ref.origin === location.origin && ref.pathname !== location.pathname) dest = ref.href;
      } catch (e) {}
      window.location.href = dest;
    }

    /* ---------- upload confirm modal ---------- */
    var mConfirm = root.querySelector('[data-bvb-modal="confirm-upload"]');
    function openConfirmUpload() {
      var tries = mConfirm.querySelector('[data-bvb-tries]');
      if (tries) {
        var left = MAX_UPLOADS - state.uploadAttempts - 1;
        tries.textContent = left >= 0 ? (left + ' ' + (left <= 1 ? 'try' : 'tries') + ' left') : '';
        tries.style.display = left >= 0 && state.uploadAttempts > 0 ? 'block' : 'none';
      }
      openModal(mConfirm);
    }
    if (mConfirm) {
      mConfirm.addEventListener('click', function (e) {
        if (e.target.closest('[data-bvb-confirm-ok]')) {
          state.uploadAttempts++;
          closeModal(mConfirm);
          applyUploaded();
          save();
        } else if (e.target.closest('[data-bvb-confirm-reupload]')) {
          state.uploadAttempts++;
          closeModal(mConfirm);
          if (state.uploadAttempts >= MAX_UPLOADS) { setUploadView('max'); trackPdfExhausted(); }
          else { openPicker(); }
        } else if (e.target.closest('[data-bvb-modal-close]') || e.target.closest('.bvb-modal__overlay')) {
          closeModal(mConfirm);
        }
      });
    }

    /* ---------- leave modal ---------- */
    var mLeave = root.querySelector('[data-bvb-modal="leave"]');
    // Anything the user would lose by leaving — answers entered or a report picked.
    function hasEnteredData() {
      var a = state.answers || {};
      for (var k in a) {
        if (!a.hasOwnProperty(k)) continue;
        var v = a[k];
        if (v != null && v !== '' && !(Array.isArray(v) && !v.length)) return true;
      }
      return !!state.fileMeta;
    }
    function maybeLeave() {
      // Warn when past the first step OR when data was entered on it (e.g. the book
      // journey's first step IS the questionnaire, so state.step is 0 there).
      if ((state.step > 0 || hasEnteredData()) && !confirmActive()) openModal(mLeave);
      else exitFlow();
    }
    function exitFlow() {
      postAppBack();
      if (window.history.length > 1 && document.referrer) window.history.back();
      else window.location.href = HOME_URL;
    }
    if (mLeave) {
      mLeave.addEventListener('click', function (e) {
        if (e.target.closest('[data-bvb-leave-stay]') || e.target.closest('[data-bvb-modal-close]') || e.target.closest('.bvb-modal__overlay')) {
          closeModal(mLeave);
        } else if (e.target.closest('[data-bvb-leave-go]')) {
          // Keep saved progress so the user can resume later — same as exiting via Back.
          trackJourneyDropOff();
          postAppBack();
          window.location.href = HOME_URL;
        }
      });
    }
    var backArrow = root.querySelector('[data-bvb-back]');
    if (backArrow) backArrow.addEventListener('click', function (e) { e.preventDefault(); maybeLeave(); });

    // Keep the browser/device Back button in sync with the on-screen back (X) control:
    // a Back press runs the same leave-guard instead of silently abandoning the flow.
    // The steps aren't real history entries, so we seed one same-URL "trap" entry and
    // catch the press in popstate. Re-armed whenever we want to stay on the page.
    if (!window.__bvbBackSync) {
      window.__bvbBackSync = true;
      var armBackTrap = function () { try { history.pushState({ bvb: 'trap' }, ''); } catch (e) {} };
      armBackTrap();
      window.addEventListener('popstate', function () {
        // A modal is open → Back just closes it and stays on the page (mirrors Escape).
        if (anyModalOpen()) {
          Array.prototype.forEach.call(root.querySelectorAll('.bvb-modal.is-open'), function (m) {
            if (m.getAttribute('data-bvb-modal') !== 'resume') closeModal(m);
          });
          armBackTrap();
          return;
        }
        // Same guard as the on-screen back button (maybeLeave): warn before leaving when
        // there's progress; otherwise let the flow exit for real (the trap is already spent).
        if ((state.step > 0 || hasEnteredData()) && !confirmActive()) {
          armBackTrap();        // stay on the page behind the leave modal
          openModal(mLeave);
        } else {
          exitFlow();
        }
      });
    }


    /* ---------- review ---------- */
    var CUR = S.currency || '₹';
    function isBook() { return journey === 'book'; }
    function planSale() { return isBook() ? S.bookSalePrice : S.salePrice; }
    function planCompare() { return isBook() ? S.bookComparePrice : S.comparePrice; }
    function planTitle() { return isBook() ? S.bookPlanTitle : S.planTitle; }
    function setText(sel, val) { var e = reviewEl.querySelector(sel); if (e) e.textContent = val; }
    // Continue/Pay button label: on mobile (≤749px) show "Pay ₹299"; desktop keeps the plain label.
    function payLabelText() {
      var base = S.payLabel || S.continueLabel || 'Continue';
      var sale = planSale();
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      return (isMobile && sale != null && sale !== '') ? ('Pay ' + CUR + sale) : base;
    }
    function refreshPayLabel() {
      if (!reviewEl) return;
      var b = reviewEl.querySelector('[data-bvb-next]');
      if (b && !b.disabled) b.textContent = payLabelText(); // don't clobber the "Processing…" busy state
    }
    function renderReview() {
      refreshPayLabel();
      setText('[data-bvb-review-title]', planTitle());
      var book = isBook();
      setText('[data-bvb-review-detail-label]', book ? 'Booked:' : 'Report:');
      setText('[data-bvb-review-report]', book
        ? ((state.slot.date || '') + (state.slot.time ? ' at ' + state.slot.time : '')) || (S.reportFallback || '—')
        : (state.fileMeta ? state.fileMeta.name : (S.reportFallback || '—')));
      var cmp = reviewEl.querySelector('[data-bvb-review-compare]');
      if (cmp) {
        if (planCompare()) { cmp.textContent = CUR + ' ' + planCompare(); cmp.style.display = ''; }
        else { cmp.style.display = 'none'; }
      }
      setText('[data-bvb-review-sale]', CUR + ' ' + (planSale() != null ? planSale() : ''));
    }

    /* ---------- checkout ---------- */
    // Variant id is configured per journey in the theme editor.
    function planVariantId() { return isBook() ? S.bookVariantId : S.uploadVariantId; }
    function cartRootUrl() {
      return (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root : '/';
    }
    // Line-item attributes carried into the order for post-purchase / Resolute traceability.
    function checkoutAttributes() {
      var attrs = [
        { key: 'is-blood-view', value: 'true' },
        { key: '_journey',      value: journey },
        { key: '_customerId',   value: String(USER_ID || '') },
        { key: '_bookingFor',   value: String(state.bookingFor || '') }
      ];
      if (isBook()) {
        attrs.push({ key: '_appointmentDate', value: state.slot.date || '' });
        attrs.push({ key: '_appointmentTime', value: state.slot.time || '' });
        attrs.push({ key: '_address',          value: state.slot.address || '' });
        attrs.push({ key: '_flat',             value: state.slot.flat || '' });
        attrs.push({ key: '_landmark',         value: state.slot.landmark || '' });
        attrs.push({ key: '_email',            value: state.slot.email || '' });
        attrs.push({ key: '_city',             value: state.slot.city || '' });
        attrs.push({ key: '_state',            value: state.slot.state || '' });
        attrs.push({ key: '_pincode',          value: state.slot.pincode || '' });
        if (state.isReschedule && state.slot.reschedule_reason) {
          attrs.push({ key: '_rescheduleReason', value: state.slot.reschedule_reason });
        }
      } else if (state.fileMeta) {
        attrs.push({ key: '_reportName', value: state.fileMeta.name || '' });
        if (state.reportUrl) attrs.push({ key: '_reportUrl', value: state.reportUrl });
      }
      return attrs;
    }
    function restoreContinue(btn) {
      if (btn) { btn.disabled = false; btn.textContent = payLabelText(); }
    }
    // Keep the Pay/Continue label in sync when crossing the mobile breakpoint.
    if (window.matchMedia) {
      var bvbPayMq = window.matchMedia('(max-width: 749px)');
      var onBvbPayMq = function () { if (reviewEl && reviewEl.classList.contains('is-active')) refreshPayLabel(); };
      if (bvbPayMq.addEventListener) bvbPayMq.addEventListener('change', onBvbPayMq);
      else if (bvbPayMq.addListener) bvbPayMq.addListener(onBvbPayMq);
    }

    // Inline error on the Review & Pay footer (mirrors qErr / bookingErr).
    function reviewErr(msg) {
      if (!reviewEl) return;
      var e = reviewEl.querySelector('[data-bvb-review-error]');
      if (!e) {
        e = el('p', 'bvb-error', { 'data-bvb-review-error': '', role: 'alert' });
        var f = reviewEl.querySelector('.bvb-footer');
        if (f) reviewEl.insertBefore(e, f); else reviewEl.appendChild(e);
      }
      e.textContent = msg || ''; e.style.display = msg ? 'block' : 'none';
    }
    var CART_LINK_ERR = S.cartLinkError || 'We couldn’t start your checkout. Please try again.';

    // gid://shopify/Cart/c1-xxxx?key=yyyy → c1-xxxx (the order's cart_token).
    function cartToken(cartGid) {
      if (!cartGid) return '';
      var s = String(cartGid).split('?')[0];
      var i = s.lastIndexOf('/');
      return i >= 0 ? s.slice(i + 1) : s;
    }

    // Establishes the cartId ↔ customerId join so the orders/paid webhook can find the
    // journey by cart_token and fire Resolute PAYMENT_STATUS. Resolves as a no-op when the
    // API isn't configured (keeps the demo/legacy flow working); rejects on a real failure
    // or a missing token so checkout is blocked and the user can retry.
    function linkCart(cartId) {
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      if (!base || !USER_ID) return Promise.resolve();
      if (!cartId) return Promise.reject(new Error('no cart token'));
      return fetch(base + '/api/v2/bloodview/cart/link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: USER_ID, cartId: cartId })
      })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (res) { if (!(res && res.data && res.data.ok)) throw new Error('not ok'); });
    }

    // Feature flag = "native": build a cart via the Storefront API and redirect to its checkoutUrl.
    function nativeCheckout(variantId, btn) {
      var cartRoot = cartRootUrl();
      var token = S.storefrontToken || '';
      var apiVersion = S.storefrontApiVersion || '2026-10';
      var shopDomain = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : window.location.hostname;
      if (!token || !variantId) { window.location.href = cartRoot + 'checkout'; return; }

      var mutation = 'mutation cartCreate($input: CartInput!) { cartCreate(input: $input) { cart { id checkoutUrl } userErrors { field message } } }';
      var cartInput = {
        lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1, attributes: checkoutAttributes() }],
        attributes: [{ key: 'resolute_customer_id', value: String(USER_ID || '') }], // cart-level → order attribute
        buyerIdentity: { countryCode: 'IN' }
      };
      if (isBook()) {
        if (state.slot.email) cartInput.buyerIdentity.email = state.slot.email;
        cartInput.buyerIdentity.deliveryAddressPreferences = [{ deliveryAddress: {
          address1: state.slot.address || '',
          address2: [state.slot.flat, state.slot.landmark].filter(Boolean).join(', '),
          city: state.slot.city || '',
          province: state.slot.state || '',
          zip: state.slot.pincode || '',
          country: 'IN'
        }}];
      }
      fetch('https://' + shopDomain + '/api/' + apiVersion + '/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
        body: JSON.stringify({ query: mutation, variables: { input: cartInput } })
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var cart = res && res.data && res.data.cartCreate && res.data.cartCreate.cart;
        // No cart/checkoutUrl → we can't establish the cartId↔customerId join, so block.
        if (!(cart && cart.checkoutUrl)) { reviewErr(CART_LINK_ERR); restoreContinue(btn); return; }
        reviewErr('');
        return linkCart(cartToken(cart.id))
          .then(function () { restoreContinue(btn); window.location.href = cart.checkoutUrl; }) // re-enable for back/bfcache return
          .catch(function () { reviewErr(CART_LINK_ERR); restoreContinue(btn); });
      })
      .catch(function () { reviewErr(CART_LINK_ERR); restoreContinue(btn); });
    }

    // Feature flag = "gokwik": clear cart, add the variant, then open the GoKwik custom checkout.
    // Set true once we open the GoKwik overlay; gates the cart cleanup so we only ever clear a
    // cart we actually started checkout for.
    var bvbCheckoutOpened = false;
    function gokwikCheckout(variantId, btn) {
      var cartRoot = cartRootUrl();
      function openCheckout() {
        // Open the moment GoKwik is ready: check immediately, then poll fast (100ms) instead
        // of waiting a fixed 500ms before the first check.
        var attempts = 0, maxAttempts = 100; // ~10s ceiling before falling back to /checkout
        function tryOpen() {
          var ready = typeof GoKwikChat !== 'undefined' || window.KwikCheckout ||
                      typeof onCheckoutClick === 'function' || typeof window.triggerGokwikCustomCheckout === 'function';
          if (!ready) return false;
          bvbCheckoutOpened = true;
          // Checkout is opening (GoKwik renders as an on-page overlay). Re-enable Continue
          // now so the button works if the user dismisses checkout without completing it.
          restoreContinue(btn);
          if (typeof window.triggerGokwikCustomCheckout === 'function') { window.triggerGokwikCustomCheckout(); }
          else if (typeof onCheckoutClick === 'function') {
            var b = document.getElementById('gokwik-checkout-btn');
            if (b) onCheckoutClick(b); else onCheckoutClick({ id: 'gokwik-checkout-btn' });
          } else { window.location.href = cartRoot + 'checkout'; }
          return true;
        }
        if (tryOpen()) return;
        var timer = setInterval(function () {
          attempts++;
          if (tryOpen()) { clearInterval(timer); return; }
          if (attempts >= maxAttempts) { clearInterval(timer); window.location.href = cartRoot + 'checkout'; }
        }, 100);
      }
      if (!variantId) { openCheckout(); return; }

      var params = { id: String(variantId), quantity: '1' };
      checkoutAttributes().forEach(function (a) { params['properties[' + a.key + ']'] = a.value; });
      var addBody = new URLSearchParams(params).toString();

      fetch(cartRoot + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch(cartRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: addBody
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status);
          // Stamp the Resolute customerId on the cart (→ order attribute).
          return fetch(cartRoot + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            // Stamp our customerId, and null out stale cart attributes left on this browser
            // cart by the prefilled-cart flow (wbn-prefilled-cart.js) — cart/clear.js only
            // removes line items, not attributes, so these would otherwise leak into the order.
            body: JSON.stringify({ attributes: {
              resolute_customer_id: String(USER_ID || ''),
              'is-upload-blood-report': '',
              '_wbn_prefilled_cart': '',
              'Customer': ''
            } })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('update ' + r.status); return r.json(); })
        .then(function (cart) { return linkCart(cart && cart.token); }) // cart/update.js returns the full cart (incl. token) — saves a separate cart.js round-trip
        .then(function () {
          reviewErr('');
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          openCheckout();
        })
        .catch(function () { reviewErr(CART_LINK_ERR); restoreContinue(btn); });
    }

    // After the GoKwik overlay closes — whether the user abandoned checkout or completed
    // payment — the booking variant must not linger in the cart. Clear it once. (Mirrors the
    // blood-slot-booking page's modal_closed / order_create_success handling.) Guarded by
    // bvbCheckoutOpened so we never clear a cart we didn't open a checkout for.
    // Returns a promise that resolves once the cart has been wiped (so callers can wait before
    // navigating). Clears the line item AND nulls resolute_customer_id — cart/clear.js only
    // removes line items, not cart attributes, so without the follow-up update this attempt's
    // customerId would linger on the cart and leak (stale) into whatever order is placed next.
    // Wiping it here keeps it from ever going stale: the next checkout re-stamps the current
    // customerId in gokwikCheckout/nativeCheckout before opening checkout.
    // Clears the booking line item AND nulls resolute_customer_id, unconditionally. Used both
    // when checkout is abandoned and (post-reload) after a completed payment.
    function bvbWipeCart() {
      return fetch(cartRootUrl() + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch(cartRootUrl() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { resolute_customer_id: '' } })
          });
        })
        .then(function (r) { if (r && r.ok) document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); })
        .catch(function () {});
    }
    function bvbClearCartAfterCheckout() {
      if (!bvbCheckoutOpened) return Promise.resolve();
      bvbCheckoutOpened = false;
      var p = bvbWipeCart();
      var btn = reviewEl && reviewEl.querySelector('[data-bvb-next]');
      if (btn) restoreContinue(btn);
      return p;
    }
    // A completed GoKwik payment otherwise navigates to GoKwik's own thank-you page. Instead,
    // remove the booking item from the cart, then reload THIS page so it lands on the
    // confirmation screen — on boot checkPaidJourney() polls the (async) paid journey and
    // renders showPaidConfirmation with the real order id. Runs once; the success flag survives
    // the reload so the confirmation poll is guaranteed.
    var bvbSuccessHandled = false;
    function bvbOnCheckoutSuccess() {
      if (bvbSuccessHandled) return;
      bvbSuccessHandled = true;
      try { sessionStorage.setItem('bvb_checkout_success_' + journey, '1'); } catch (e) {}
      bvbCheckoutOpened = false;
      // Redirect to OUR confirmation immediately so we beat GoKwik's own thank-you-page
      // redirect (awaiting the cart wipe here let GoKwik win the race). The leftover booking
      // item is wiped after the reload — see checkPaidJourney()'s justPaid branch — because
      // navigating now would abort an in-flight cart cleanup.
      window.location.replace(location.pathname + location.search);
    }
    var bvbPaidPollStarted = false;
    function bvbVerifyPaidThenReload() {
      if (bvbSuccessHandled || bvbPaidPollStarted) return;
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      var uid = USER_ID || storedUserId;
      if (!base || !uid) { bvbOnCheckoutSuccess(); return; } // can't verify — keep the reload
      bvbPaidPollStarted = true;
      var attempts = 0, MAX = 150; // ~5 min at 2s — a QR payment can take a while
      (function poll() {
        attempts++;
        fetch(base + '/api/v2/bloodview/journey/' + encodeURIComponent(uid), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .then(function (res) {
            var d = res && res.data;
            var paid = !!(d && d.step === 'paid' && ((d.booking && d.booking.resoluteOrderId) || d.resoluteOrderId) != null);
            if (paid) { bvbOnCheckoutSuccess(); return; }
            if (attempts < MAX) setTimeout(poll, 2000); else bvbPaidPollStarted = false;
          })
          .catch(function () { if (attempts < MAX) setTimeout(poll, 2000); else bvbPaidPollStarted = false; });
      })();
    }
    function bvbAttachGokwikListeners() {
      if (window.gokwikSdk && typeof window.gokwikSdk.on === 'function') {
        window.gokwikSdk.on('order_create_success', bvbVerifyPaidThenReload);
        window.gokwikSdk.on('modal_closed', bvbClearCartAfterCheckout);
      }
    }
    if (window.gokwikSdk) bvbAttachGokwikListeners();
    else window.addEventListener('gokwikLoaded', bvbAttachGokwikListeners);
    window.addEventListener('message', function (e) {
      if (e.data === 'order_create_success' || (e.data && e.data.type === 'kp_order_success')) bvbVerifyPaidThenReload();
    });

    function submit() {
      var detail = {
        userId: USER_ID,
        answers: state.answers,
        bookingFor: state.bookingFor,
        journey: state.journey,
        slot: isBook() ? state.slot : null,
        file: state.file,
        fileMeta: state.fileMeta,
        plan: { title: planTitle(), sale: planSale(), compare: planCompare(), currency: CUR }
      };
      var ev;
      try { ev = new CustomEvent('bvb:submit', { bubbles: true, cancelable: true, detail: detail }); }
      catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('bvb:submit', true, true, detail); }
      var notPrevented = root.dispatchEvent(ev);
      if (!notPrevented) return; // host took over (e.g. real payment)

      var variantId = planVariantId();
      var btn = reviewEl.querySelector('[data-bvb-next]');

      // No variant configured for this journey → keep the legacy behaviour.
      if (!variantId) {
        if (S.checkoutUrl) { window.location.href = S.checkoutUrl; return; }
        showConfirmation(); // demo / fallback
        return;
      }

      if (btn) { btn.disabled = true; btn.textContent = S.payingLabel || 'Processing…'; }
      if ((S.checkoutType || 'gokwik') === 'native') { nativeCheckout(variantId, btn); }
      else { gokwikCheckout(variantId, btn); }
    }

    // Reschedule is free — no checkout. A host/API can take over via the cancelable
    // event (e.g. the Resolute reschedule API); otherwise we confirm inline.
    function exitReschedule() {
      state.isReschedule = false;
      state.rescheduleFromConfirm = false;
      if (slotEl) slotEl.classList.remove('is-reschedule');
    }
    // Reschedule deep-link entry: the customerId comes from the URL, so look up its journey and
    // prefill the slot form with the booked details. Shows the page loader while in flight and
    // falls back silently to whatever local progress was already hydrated.
    function prefillRescheduleFromServer() {
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      if (!base || !USER_ID) return;
      showLoader();
      var done = false, hide = function () { if (done) return; done = true; hideLoader(); };
      var safety = setTimeout(hide, 8000); // never trap the user behind a hung request
      fetch(base + '/api/v2/bloodview/journey/' + encodeURIComponent(USER_ID), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (res) {
          var d = res && res.data;
          if (d) {
            if (d.customerId) USER_ID = d.customerId;
            lastJourney = d;             // lets "Back" from reschedule re-show the confirmation
            prefillSlotFromJourney(d);
          }
          clearTimeout(safety); hide();
        })
        .catch(function () { clearTimeout(safety); hide(); });
    }
    // Re-fetch the journey so the confirmation reflects the new slot; fall back to the last doc.
    function confirmFromServer() {
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      if (!base || !USER_ID) { if (lastJourney) showPaidConfirmation(lastJourney); return; }
      fetch(base + '/api/v2/bloodview/journey/' + encodeURIComponent(USER_ID), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (res) { var d = res && res.data; showPaidConfirmation(d || lastJourney); })
        .catch(function () { if (lastJourney) showPaidConfirmation(lastJourney); });
    }
    // CleverTap: fired when the reschedule API confirms the new slot (200/ok).
    function trackRescheduleConfirmed(res) {
      var jd = (res && res.data) || lastJourney || {};
      var orderId = (jd.booking && jd.booking.resoluteOrderId) || jd.resoluteOrderId || jd.shopifyOrderName ||
        (lastJourney && ((lastJourney.booking && lastJourney.booking.resoluteOrderId) || lastJourney.resoluteOrderId || lastJourney.shopifyOrderName)) || '';
      var payload = {
        customer_id: USER_ID || '',
        order_id: orderId,
        new_slot_date: state.slot.date || '',
        new_slot_time: state.slot.time || ''
      };
      if (typeof clevertap === 'undefined' || !clevertap.event || typeof clevertap.event.push !== 'function') return;
      clevertap.event.push('reschedule_confirmed', payload);
    }
    function rescheduleSubmit() {
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      // No endpoint/id → keep the legacy cancelable-event fallback, then return to confirmation.
      if (!base || !USER_ID) {
        var detail = { userId: USER_ID, customerId: USER_ID, journey: journey, slot: state.slot, reason: state.slot.reschedule_reason || '' };
        var ev;
        try { ev = new CustomEvent('bvb:reschedule', { bubbles: true, cancelable: true, detail: detail }); }
        catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('bvb:reschedule', true, true, detail); }
        if (!root.dispatchEvent(ev)) return; // host took over
        exitReschedule();
        if (lastJourney) showPaidConfirmation(lastJourney); else showConfirmation();
        return;
      }
      setBookingBusy(true); bookingErr('');
      fetch(base + '/api/v2/bloodview/reschedule', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: USER_ID,
          flat: state.slot.flat || '',
          landmark: state.slot.landmark || '',
          email: state.slot.email || '',
          address: state.slot.address || '',
          city: state.slot.city || '',
          state: state.slot.state || '',
          pincode: state.slot.pincode || '',
          date: state.slot.date || '',
          time: state.slot.time || '',
          reason: state.slot.reschedule_reason || ''
        })
      })
      .then(function (r) {
        if (r.status === 409) { var e409 = new Error('no booking'); e409.code = 'NO_BOOKING'; throw e409; }
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (res) {
        setBookingBusy(false);
        if (!(res && res.data && res.data.ok)) throw new Error('not ok');
        trackRescheduleConfirmed(res); // CleverTap: reschedule_confirmed (API returned 200/ok)
        exitReschedule();
        confirmFromServer(); // → updated confirmation screen
      })
      .catch(function (err) {
        setBookingBusy(false);
        bookingErr(err && err.code === 'NO_BOOKING'
          ? 'We couldn’t find a booking to reschedule.'
          : 'We couldn’t reschedule your booking. Please try again.');
      });
    }

    function randomOrderId() {
      var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789', s = '';
      for (var i = 0; i < 8; i++) s += chars.charAt(Math.floor(Math.random() * chars.length));
      return 'BV-' + s;
    }
    function showConfirmation() {
      stepEls.forEach(function (n) { n.classList.remove('is-active'); });
      var oid = confirmEl.querySelector('[data-bvb-order-id]');
      var amt = confirmEl.querySelector('[data-bvb-amount]');
      var desc = confirmEl.querySelector('[data-bvb-confirm-desc]');
      var resch = confirmEl.querySelector('[data-bvb-reschedule]');
      if (oid) oid.textContent = randomOrderId();
      if (amt) amt.textContent = CUR + (planSale() != null ? planSale() : '');
      if (desc && isBook() && S.bookConfirmDesc) desc.textContent = S.bookConfirmDesc;
      if (resch) resch.hidden = !isBook();
      var demoSummary = confirmEl.querySelector('[data-bvb-reschedule-summary]');
      if (demoSummary) demoSummary.hidden = true; // demo path has no booking data
      markJourneyDone();
      confirmEl.classList.add('is-active');
      hideProgress();
      //clearSaved();
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    }

    // Old/new booking summary (shown after a reschedule). A booking carries date/time + address parts.
    function fmtBookingDate(s) {
      if (!s) return '';
      var m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})/);   // YYYY-MM-DD → DD-MM-YYYY
      return m ? (m[3] + '-' + m[2] + '-' + m[1]) : String(s);
    }
    function bookingAddress(b) {
      return [b.flat, b.address, b.landmark, b.city, b.state, b.pincode]
        .filter(function (p) { return p != null && String(p).trim() !== ''; }).join(', ');
    }
    function fillBookingCol(which, b) {
      var set = function (attr, val) {
        var n = confirmEl.querySelector('[data-bvb-' + which + '-' + attr + ']');
        if (n) n.textContent = val || '—';
      };
      set('date', fmtBookingDate(b && b.date));
      set('time', (b && b.time) || '');
      set('address', b ? bookingAddress(b) : '');
    }
    // After a reschedule the journey carries the previous slot(s) in pastBookings; show
    // pastBookings[0] as "old" alongside the current booking as "new". No past bookings → hide.
    function renderRescheduleSummary(d) {
      var summaryEl = confirmEl.querySelector('[data-bvb-reschedule-summary]');
      if (!summaryEl) return;
      var past = (d && d.pastBookings && d.pastBookings.length) ? d.pastBookings[0] : null;
      if (past && d.booking) {
        fillBookingCol('old', past);
        fillBookingCol('new', d.booking);
        summaryEl.hidden = false;
      } else {
        summaryEl.hidden = true;
      }
    }

    // Render the order-confirmed page from a paid journey document (GET /journey).
    var lastJourney = null; // last confirmation doc — lets reschedule "Back" re-show it
    // Map a server journey doc's booking (+ top-level email) into the slot form and reflect it
    // in the DOM. email lives at the journey top level (d.email), not inside d.booking, so fall
    // back to d.email. No-op when the journey has no booking yet.
    function prefillSlotFromJourney(d) {
      if (!d || !d.booking) return;
      var b = d.booking;
      state.slot = {
        flat: b.flat || '', landmark: b.landmark || '', email: b.email || d.email || '', address: b.address || '', city: b.city || '',
        state: b.state || '', pincode: b.pincode || '', date: b.date || '', time: b.time || '',
        reschedule_reason: ''
      };
      hydrateSlot();
    }
    function showPaidConfirmation(d) {
      if (!confirmEl || !d) return;
      var isBookFlow = d.flowType === 'booking';
      var oid = confirmEl.querySelector('[data-bvb-order-id]');
      var amt = confirmEl.querySelector('[data-bvb-amount]');
      var desc = confirmEl.querySelector('[data-bvb-confirm-desc]');
      var resch = confirmEl.querySelector('[data-bvb-reschedule]');
      // Order ID = Resolute order id (under booking for the slot flow).
      var orderId = (d.booking && d.booking.resoluteOrderId) || d.resoluteOrderId || d.shopifyOrderName || '';
      // Amount by the journey's own flowType: booking → slot price, else upload price.
      var price = isBookFlow ? S.bookSalePrice : S.salePrice;
      stepEls.forEach(function (n) { n.classList.remove('is-active'); });
      if (oid) oid.textContent = orderId || '—';
      if (amt) amt.textContent = CUR + (price != null ? price : '');
      if (desc && isBookFlow && S.bookConfirmDesc) desc.textContent = S.bookConfirmDesc;
      // Reschedule is offered for the book flow, with no cap — the button stays available
      // regardless of how many times the user has already rescheduled (past bookings).
      if (resch) resch.hidden = !isBookFlow;
      renderRescheduleSummary(d); // old vs new booking (only when there are past bookings)
      if (d.customerId) USER_ID = d.customerId; // ensure reschedule uses the right id
      lastJourney = d;
      // Prefill the slot step from the confirmed booking so reschedule isn't blank.
      if (isBookFlow) prefillSlotFromJourney(d);
      confirmEl.classList.add('is-active');
      hideProgress();
      //clearSaved();
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    }

    // On landing: look up the stored journey. If it's paid, show the confirmation screen.
    // The orders/paid webhook is async, so we poll — but only when payment was plausibly
    // started (the saved local step had reached Review/Pay); otherwise a single check.
    function showLoader() {
      if (!root || root.querySelector('[data-bvb-loader]')) return;
      var l = document.createElement('div');
      l.className = 'bvb-loader'; l.setAttribute('data-bvb-loader', ''); l.setAttribute('aria-busy', 'true');
      l.innerHTML = '<span class="bvb-loader__spinner" aria-hidden="true"></span>';
      root.appendChild(l);
    }
    function hideLoader() {
      var l = root && root.querySelector('[data-bvb-loader]');
      if (l && l.parentNode) l.parentNode.removeChild(l);
    }
    // CleverTap: fired once per order when the backend confirms the journey as paid (i.e. a
    // successful checkout). Guarded via localStorage so a reload/re-poll doesn't re-fire.
    function trackPurchaseCompleted(d) {
      var orderId = (d && ((d.booking && d.booking.resoluteOrderId) || d.resoluteOrderId || d.shopifyOrderName)) || '';
      var firedKey = 'bvb_purchase_fired_' + journey;
      try { if (orderId && localStorage.getItem(firedKey) === String(orderId)) return; } catch (e) {}
      var isBookFlow = (d && d.flowType === 'booking') || isBook();
      var price = isBookFlow ? S.bookSalePrice : S.salePrice;
      var orderValue = (d && d.orderValue != null) ? d.orderValue : ((d && d.amount != null) ? d.amount : price);
      var payload = {
        order_id: orderId,
        order_value: orderValue != null ? orderValue : '',
        flow_type: isBookFlow ? 'booking' : 'upload',
        utm_source: bvbUtmParam('utm_source') || 'organic',
        utm_campaign: bvbUtmParam('utm_campaign') || null,
        utm_medium: bvbUtmParam('utm_medium') || null,
        utm_term: bvbUtmParam('utm_term') || null,
        customer_id: (d && d.customerId) || USER_ID || ''
      };
      if (typeof clevertap === 'undefined' || !clevertap.event || typeof clevertap.event.push !== 'function') return;
      clevertap.event.push('purchase_completed', payload);
      try { if (orderId) localStorage.setItem(firedKey, String(orderId)); } catch (e) {}
    }
    function checkPaidJourney() {
      if (IS_RESCHEDULE || !storedUserId) return;
      var base = (S.newflowapiBaseUrl || '').replace(/\/+$/, '');
      if (!base) return;
      var savedJ = loadSaved();
      // Set by bvbOnCheckoutSuccess just before reloading after a completed GoKwik payment —
      // forces the paid-journey poll even if local progress is missing.
      var justPaid = false;
      try {
        justPaid = sessionStorage.getItem('bvb_checkout_success_' + journey) === '1';
        if (justPaid) sessionStorage.removeItem('bvb_checkout_success_' + journey);
      } catch (e) {}
      // Payment just completed and we reloaded straight here (beating GoKwik's thank-you page),
      // so the booking item + stale customerId were never cleared mid-checkout — wipe them now.
      if (justPaid) bvbWipeCart();
      var atCheckout = justPaid || !!(savedJ && savedJ.step != null && savedJ.step >= TOTAL - 1);
      var attempts = 0, MAX = atCheckout ? 20 : 1; // ~60s of polling only if checkout was reached
      showLoader();
      // Safety net so a hung request never traps the user behind the loader. After a fresh
      // payment we keep the loader up across the whole poll (~60s), so the cap must outlast it.
      var loaderSafety = setTimeout(hideLoader, justPaid ? 65000 : 8000);
      function done() { clearTimeout(loaderSafety); hideLoader(); }
      (function poll() {
        attempts++;
        fetch(base + '/api/v2/bloodview/journey/' + encodeURIComponent(storedUserId), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (r.status === 404) return null; if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .then(function (res) {
            var d = res && res.data;
            var resoluteOrderId = d && ((d.booking && d.booking.resoluteOrderId) || d.resoluteOrderId);
            var terminal = !!(d && d.step === 'paid' && resoluteOrderId != null);
            if (terminal) { markJourneyDone(); trackPurchaseCompleted(d); showPaidConfirmation(d); done(); return; } // hide loader as the confirmation appears
            if (attempts < MAX) {
              // After a fresh payment, hold the loader until the confirmation renders; otherwise
              // (a normal resume) hide it after the first check so the user can keep using the page.
              if (!justPaid && attempts === 1) hideLoader();
              setTimeout(poll, 3000);
            } else { done(); } // polling exhausted without a paid journey
          })
          .catch(function () {
            if (attempts < MAX) { if (!justPaid && attempts === 1) hideLoader(); setTimeout(poll, 3000); }
            else { done(); }
          });
      })();
    }

    /* ---------- persistence ---------- */
    // Debug: dump the saved localStorage for every journey (+ its per-journey customerId).
    function logStorage(tag) {
      try {
        var userBase = S.userKey || 'bvb_user_id';
        var storeBase = S.storageKey || 'bvb_journey_v1';
        var dump = {};
        ['upload', 'book'].forEach(function (j) {
          dump[userBase + '_' + j] = localStorage.getItem(userBase + '_' + j) || null;
          var v = localStorage.getItem(storeBase + '_' + j);
          dump[storeBase + '_' + j] = v ? JSON.parse(v) : null;
        });
        console.log('>>>>>>>>>>>>>>>[bvb] localStorage' + (tag ? ' (' + tag + ')' : '') + ':', dump);
      } catch (e) {}
    }
    function save() {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify({
          step: state.step, answers: state.answers, bookingFor: state.bookingFor,
          fileMeta: state.fileMeta, uploadAttempts: state.uploadAttempts,
          reportUrl: state.reportUrl, uploadValidated: state.uploadValidated,
          questionnaireSubmitted: state.questionnaireSubmitted,
          bookingConfirmed: state.bookingConfirmed, resoluteOrderId: state.resoluteOrderId,
          journey: journey, slot: state.slot, ts: Date.now()
        }));
      } catch (e) {}
      logStorage('save:' + journey);
    }
    function loadSaved() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }
    function clearSaved() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} }
    // Mark this journey as completed (confirmation screen seen). The landing-page resume
    // modal reads this to skip the "continue vs new" prompt — the CTA starts fresh instead.
    function markJourneyDone() { try { localStorage.setItem('bvb_journey_done_' + journey, String(Date.now())); } catch (e) {} }

    function hydrateAnswers() {
      // reflect restored answers into the DOM
      QUESTIONS.forEach(function (q) {
        var node = root.querySelector('[data-step="q-' + q.key + '"]');
        if (!node) return;
        (q.groups || []).forEach(function (g) {
          var v = state.answers[g.key];
          if (v == null) return;
          if (g.type === 'text' || g.type === 'number') {
            var inp = node.querySelector('[data-field="' + g.key + '"]');
            if (inp) inp.value = v;
            if (apiKeyFor(g) === 'phone') state.phone = v; // keep the questionnaire API phone in sync on resume
          } else {
            var vals = Array.isArray(v) ? v : [v];
            vals.forEach(function (opt) {
              var c = node.querySelector('[data-chips="' + g.key + '"] [data-option="' + cssEsc(opt) + '"]');
              if (c) c.classList.add('is-selected');
            });
          }
        });
      });
    }
    function applyResume() {
      var saved = loadSaved();
      if (!saved) return;
      state.answers = saved.answers || {};
      state.bookingFor = saved.bookingFor || 'myself';
      state.fileMeta = saved.fileMeta || null;
      state.uploadAttempts = saved.uploadAttempts || 0;
      state.reportUrl = saved.reportUrl || '';
      state.uploadValidated = !!saved.uploadValidated;
      state.questionnaireSubmitted = !!saved.questionnaireSubmitted;
      state.bookingConfirmed = !!saved.bookingConfirmed;
      state.resoluteOrderId = saved.resoluteOrderId || null;
      if (saved.slot) { state.slot = saved.slot; hydrateSlot(); }
      hydrateAnswers();
      var bf = uploadEl.querySelector('[data-bvb-bookingfor][data-value="' + state.bookingFor + '"]');
      if (bf) {
        Array.prototype.forEach.call(uploadEl.querySelectorAll('[data-bvb-bookingfor]'), function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
        bf.classList.add('is-selected'); bf.setAttribute('aria-checked', 'true');
      }
      if (state.fileMeta) applyUploaded(); else setUploadView('empty');
      showStep(saved.step || 0, true);
    }

    /* ---------- modal utils ---------- */
    var lastFocus = null;
    function openModal(m) { if (!m) return; lastFocus = document.activeElement; m.classList.add('is-open'); document.body.style.overflow = 'hidden'; var f = m.querySelector('.bvb-btn'); if (f) try { f.focus(); } catch (e) {} }
    function closeModal(m) { if (!m) return; m.classList.remove('is-open'); document.body.style.overflow = ''; if (lastFocus) try { lastFocus.focus(); } catch (e) {} }
    function anyModalOpen() { return !!root.querySelector('.bvb-modal.is-open'); }
    function confirmActive() { return confirmEl && confirmEl.classList.contains('is-active'); }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && anyModalOpen()) {
        Array.prototype.forEach.call(root.querySelectorAll('.bvb-modal.is-open'), function (m) {
          if (m.getAttribute('data-bvb-modal') !== 'resume') closeModal(m);
        });
      }
    });

    /* ---------- confirmation: back to home / reschedule ---------- */
    var mReschedule = root.querySelector('[data-bvb-modal="reschedule-confirm"]');
    // Takes the user from confirmation into the slot step in reschedule mode.
    function startReschedule() {
      var si = stepEls.indexOf(slotEl);
      if (si < 0) return;
      state.isReschedule = true;
      state.rescheduleFromConfirm = true; // Back should return here, not to a prior flow step
      if (slotEl) slotEl.classList.add('is-reschedule'); // reveals "Reason for reschedule"
      confirmEl.classList.remove('is-active');
      showStep(si);
    }
    if (confirmEl) {
      confirmEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-bvb-home]')) { e.preventDefault(); window.location.href = HOME_URL; }
        else if (e.target.closest('[data-bvb-reschedule]')) {
          // Confirm intent first — the actual navigation happens on "Yes, Reschedule".
          e.preventDefault();
          openModal(mReschedule);
        }
      });
    }
    if (mReschedule) {
      mReschedule.addEventListener('click', function (e) {
        if (e.target.closest('[data-bvb-reschedule-cancel]') || e.target.closest('[data-bvb-modal-close]') || e.target.closest('.bvb-modal__overlay')) {
          closeModal(mReschedule);
        } else if (e.target.closest('[data-bvb-reschedule-confirm]')) {
          closeModal(mReschedule);
          startReschedule();
        }
      });
    }
    // Shown when, in reschedule mode, the user tries to edit a locked field (anything but date/time/reason).
    var mAddrLock = root.querySelector('[data-bvb-modal="reschedule-lock"]');
    if (mAddrLock) {
      mAddrLock.addEventListener('click', function (e) {
        if (e.target.closest('[data-bvb-addrlock-ok]') || e.target.closest('[data-bvb-modal-close]') || e.target.closest('.bvb-modal__overlay')) {
          closeModal(mAddrLock);
        }
      });
    }

    /* ---------- slot booking step (Book journey) ---------- */
    initSlot();
    function initSlot() {
      if (!slotEl) return;
      var slotInputs = slotEl.querySelectorAll('[data-slot]');
      var dateTrigger = slotEl.querySelector('[data-bvb-date-trigger]');
      var dateText = slotEl.querySelector('[data-bvb-date-text]');
      var dateHidden = slotEl.querySelector('[data-slot="date"]');
      var cal = slotEl.querySelector('[data-bvb-cal]');
      var timeTrigger = slotEl.querySelector('[data-bvb-time-trigger]');
      var timeText = slotEl.querySelector('[data-bvb-time-text]');
      var timeHidden = slotEl.querySelector('[data-slot="time"]');
      var timeList = slotEl.querySelector('[data-bvb-timelist]');
      var stateTrigger = slotEl.querySelector('[data-bvb-state-trigger]');
      var stateText = slotEl.querySelector('[data-bvb-state-text]');
      var stateHidden = slotEl.querySelector('[data-slot="state"]');
      var stateList = slotEl.querySelector('[data-bvb-statelist]');

      function slotErr(key, msg) {
        var e = slotEl.querySelector('[data-slot-error="' + key + '"]');
        if (e) { e.textContent = msg || ''; e.style.display = msg ? 'block' : 'none'; }
      }
      slotEl.__slotErr = slotErr;

      // ----- pincode serviceability (same list as blood-slot-booking) -----
      var pinInput = slotEl.querySelector('[data-slot="pincode"]');
      var pincodeModal = root.querySelector('[data-bvb-modal="pincode"]');
      var serviceablePincodes = null;
      (function loadServiceable() {
        var url = S.serviceablePincodesUrl || '';
        if (!url) return;
        try {
          fetch(url, { credentials: 'same-origin' })
            .then(function (res) { if (!res.ok) throw new Error('bad'); return res.json(); })
            .then(function (data) { serviceablePincodes = Array.isArray(data) ? data : null; })
            .catch(function () { serviceablePincodes = null; });
        } catch (e) { serviceablePincodes = null; }
      })();
      function checkPincode() {
        var v = (pinInput && pinInput.value || '').trim();
        if (!v) return true;
        if (!/^[1-9][0-9]{5}$/.test(v)) { slotErr('pincode', 'Please enter a valid 6-digit pincode'); return false; }
        // Unknown list → don't block (parity with blood-slot-booking).
        if (Array.isArray(serviceablePincodes) && serviceablePincodes.indexOf(v) === -1) {
          slotErr('pincode', 'We currently do not service this pincode.');
          openModal(pincodeModal);
          return false;
        }
        slotErr('pincode', '');
        return true;
      }
      slotEl.__checkPincode = checkPincode;
      if (pinInput) pinInput.addEventListener('blur', checkPincode);

      // ----- city / state ↔ pincode consistency (India Post) -----
      // Verifies the typed city + state actually belong to the entered pincode by looking the
      // pincode up at India Post. Results are cached per pincode. Gates Continue (see next()).
      var PIN_API = S.pincodeLookupUrl || 'https://api.postalpincode.in/pincode/';
      var pinGeoCache = {}; // pincode -> { state, places: [normalized] } | 'invalid' | 'error'
      // A few commonly-renamed places, so a valid address picked one way doesn't fail the other.
      var STATE_ALIASES = { orissa: 'odisha', pondicherry: 'puducherry', uttaranchal: 'uttarakhand' };
      var CITY_ALIASES = {
        gurugram: 'gurgaon', bengaluru: 'bangalore', mumbai: 'bombay', kolkata: 'calcutta',
        chennai: 'madras', pune: 'poona', kochi: 'cochin', thiruvananthapuram: 'trivandrum',
        prayagraj: 'allahabad', vadodara: 'baroda', mysuru: 'mysore', mangaluru: 'mangalore',
        belagavi: 'belgaum', varanasi: 'banaras', shimla: 'simla'
      };
      function normLoc(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
      function canonState(s) { var n = normLoc(s); return STATE_ALIASES[n] || n; }
      function canonCity(s) { var n = normLoc(s); return CITY_ALIASES[n] || n; }
      function fetchPinGeo(pin) {
        if (pinGeoCache[pin]) return Promise.resolve(pinGeoCache[pin]);
        return fetch(PIN_API + encodeURIComponent(pin))
          .then(function (r) { return r.json(); })
          .then(function (arr) {
            var rec = arr && arr[0];
            if (!rec || rec.Status !== 'Success' || !rec.PostOffice || !rec.PostOffice.length) { pinGeoCache[pin] = 'invalid'; return 'invalid'; }
            var geo = { state: canonState(rec.PostOffice[0].State), places: [] };
            rec.PostOffice.forEach(function (o) {
              ['Name', 'District', 'Block', 'Division', 'Region'].forEach(function (k) {
                if (o[k]) geo.places.push(canonCity(o[k]));
              });
            });
            pinGeoCache[pin] = geo; return geo;
          })
          .catch(function () { return 'error'; }); // not cached → a later retry can still succeed
      }
      // Returns Promise<boolean>: true = proceed, false = a mismatch error was shown.
      function verifyPincodeLocation() {
        // Reschedule carries the booked (already-valid) address forward and locks it — nothing to check.
        if (state.isReschedule) return Promise.resolve(true);
        var pin = (pinInput && pinInput.value || '').trim();
        if (!/^[1-9][0-9]{5}$/.test(pin)) return Promise.resolve(true); // format handled by validateSlot
        setBookingBusy(true);
        return fetchPinGeo(pin).then(function (geo) {
          setBookingBusy(false);
          if (geo === 'error') return true;                                   // lookup unavailable → don't block
          if (geo === 'invalid') { slotErr('pincode', 'We couldn’t verify this pincode. Please check it.'); return false; }
          var ok = true;
          var stateN = canonState(state.slot.state);
          if (stateN && stateN !== geo.state) { slotErr('state', 'State doesn’t match the pincode.'); ok = false; }
          else slotErr('state', '');
          var cityN = canonCity(state.slot.city);
          // Loose match: the city must equal, contain, or be contained by one of the pincode's places.
          var cityMatch = geo.places.some(function (p) { return p && (p === cityN || p.indexOf(cityN) !== -1 || cityN.indexOf(p) !== -1); });
          if (cityN && !cityMatch) { slotErr('city', 'City doesn’t match the pincode.'); ok = false; }
          else slotErr('city', '');
          return ok;
        });
      }
      slotEl.__verifyLocation = verifyPincodeLocation;
      if (pincodeModal) {
        pincodeModal.addEventListener('click', function (e) {
          if (e.target.closest('[data-bvb-modal-close]') || e.target.closest('.bvb-modal__overlay')) { closeModal(pincodeModal); return; }
          if (e.target.closest('[data-bvb-pincode-change]')) {
            closeModal(pincodeModal);
            if (pinInput) { try { pinInput.focus(); pinInput.select(); } catch (e2) {} }
          }
        });
      }

      // text / select fields
      Array.prototype.forEach.call(slotInputs, function (inp) {
        var key = inp.getAttribute('data-slot');
        if (key === 'date' || key === 'time' || key === 'state') return;
        var evt = inp.tagName === 'SELECT' ? 'change' : 'input';
        inp.addEventListener(evt, function () {
          if (key === 'pincode') inp.value = inp.value.replace(/[^0-9]/g, '').slice(0, 6);
          state.slot[key] = inp.value;
          state.bookingConfirmed = false; // slot changed → must re-confirm
          slotErr(key, '');
          save();
        });
      });

      // ----- date picker -----
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      var DOW = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      // Earliest bookable date — same 10 AM cutoff as the slot-booking flow:
      // before 10 AM you can book from tomorrow; from 10 AM onward, the day after.
      var now = new Date();
      var minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      minDate.setDate(minDate.getDate() + (now.getHours() < 10 ? 1 : 2));
      minDate.setHours(0, 0, 0, 0);
      var viewY = minDate.getFullYear(), viewM = minDate.getMonth();

      function renderCal() {
        var first = new Date(viewY, viewM, 1);
        var startDow = first.getDay();
        var daysInMonth = new Date(viewY, viewM + 1, 0).getDate();
        var prevDays = new Date(viewY, viewM, 0).getDate();
        var html = '<div class="bvb-cal__head">' +
          '<span class="bvb-cal__monthyear">' + MONTHS[viewM] + ' ' + viewY + '</span>' +
          '<div class="bvb-cal__nav-group">' +
          '<button type="button" class="bvb-cal__nav" data-cal-prev aria-label="Previous month">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12l6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<button type="button" class="bvb-cal__nav" data-cal-next aria-label="Next month">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '</div></div><div class="bvb-cal__weekdays">';
        DOW.forEach(function (d) { html += '<span class="bvb-cal__weekday">' + d + '</span>'; });
        html += '</div><div class="bvb-cal__divider"></div><div class="bvb-cal__days">';
        var i, d;
        for (i = startDow - 1; i >= 0; i--) html += '<button type="button" class="bvb-cal__day is-other" disabled>' + (prevDays - i) + '</button>';
        for (d = 1; d <= daysInMonth; d++) {
          var cur = new Date(viewY, viewM, d);
          var iso = viewY + '-' + pad(viewM + 1) + '-' + pad(d);
          var disabled = cur < minDate;
          var sel = state.slot.date === iso;
          html += '<button type="button" class="bvb-cal__day' + (sel ? ' is-selected' : '') + '" data-cal-day="' + iso + '"' + (disabled ? ' disabled' : '') + '>' + d + '</button>';
        }
        var trailing = (startDow + daysInMonth) % 7;
        if (trailing) for (i = 1; i <= 7 - trailing; i++) html += '<button type="button" class="bvb-cal__day is-other" disabled>' + i + '</button>';
        html += '</div>';
        cal.innerHTML = html;
        var prevBtn = cal.querySelector('[data-cal-prev]');
        if (viewY === minDate.getFullYear() && viewM === minDate.getMonth()) prevBtn.disabled = true;
      }
      function openCal() { renderCal(); cal.hidden = false; dateTrigger.setAttribute('aria-expanded', 'true'); closeTime(); scrollPickerIntoView(cal); }
      function closeCal() { cal.hidden = true; dateTrigger.setAttribute('aria-expanded', 'false'); clearPickerSpacer(); }
      // The date/time pickers float below their field (position:absolute), so on a short
      // viewport they open past the fold and get clipped. On mobile only (max-width:768px),
      // scroll the popup into view — clearing the fixed Back/Continue footer, and without
      // pushing the field label off the top when the popup is taller than the space available.
      var pickerSpacer = null;
      // Because the popup is position:absolute it never extends the page's scroll height, so
      // when it opens low in the page there's no room to scroll it up. Drop in a temporary
      // bottom spacer to create that room, then remove it when the picker closes.
      function clearPickerSpacer() { if (pickerSpacer && pickerSpacer.parentNode) pickerSpacer.parentNode.removeChild(pickerSpacer); pickerSpacer = null; }
      function scrollPickerIntoView(pop) {
        if (!pop || typeof pop.getBoundingClientRect !== 'function') return;
        if (!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches)) return; // mobile only
        requestAnimationFrame(function () {
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var topMargin = 16;
          var rect = pop.getBoundingClientRect();
          var field = pop.closest('.bvb-field') || pop;
          var fieldTop = field.getBoundingClientRect().top;
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var footer = slotEl.querySelector('.bvb-footer');
          var footerH = 0;
          if (footer) {
            var fcs = window.getComputedStyle(footer);
            if (fcs.position === 'fixed' && fcs.display !== 'none') footerH = footer.getBoundingClientRect().height;
          }
          var availBottom = vh - footerH - 12; // 12px breathing room above the footer
          if (rect.bottom <= availBottom && fieldTop >= topMargin) return; // already fully visible
          var delta = rect.bottom - availBottom; // >0 → scroll down to reveal the bottom…
          if (fieldTop - delta < topMargin) delta = fieldTop - topMargin; // …but keep the field label on screen
          if (Math.abs(delta) < 1) return;
          var targetY = Math.max(0, window.scrollY + delta);
          var maxScroll = document.documentElement.scrollHeight - vh;
          if (targetY > maxScroll) { // not enough room to scroll → add a temporary spacer
            clearPickerSpacer();
            pickerSpacer = document.createElement('div');
            pickerSpacer.setAttribute('aria-hidden', 'true');
            pickerSpacer.style.cssText = 'height:' + Math.ceil(targetY - maxScroll) + 'px;width:1px;pointer-events:none;';
            slotEl.appendChild(pickerSpacer);
          }
          window.scrollTo({ top: targetY, behavior: reduce ? 'auto' : 'smooth' });
        });
      }
      dateTrigger.addEventListener('click', function (e) { e.stopPropagation(); cal.hidden ? openCal() : closeCal(); });
      cal.addEventListener('click', function (e) {
        e.stopPropagation(); // re-rendering detaches e.target; without this the document outside-click handler would close the calendar
        var p = e.target.closest('[data-cal-prev]'); var n = e.target.closest('[data-cal-next]'); var day = e.target.closest('[data-cal-day]');
        if (p) { if (--viewM < 0) { viewM = 11; viewY--; } renderCal(); return; }
        if (n) { if (++viewM > 11) { viewM = 0; viewY++; } renderCal(); return; }
        if (day) {
          var iso = day.getAttribute('data-cal-day');
          state.slot.date = iso; dateHidden.value = iso;
          state.bookingConfirmed = false; // slot changed → must re-confirm
          dateText.textContent = iso.split('-').reverse().join('-'); // DD-MM-YYYY
          dateTrigger.classList.remove('is-placeholder');
          // Drop a previously chosen time if it isn't offered on the new date's weekday.
          if (state.slot.time && !allowedTimesFor(iso).some(function (t) { return t.label === state.slot.time; })) {
            state.slot.time = ''; timeHidden.value = ''; timeText.textContent = 'Select Time';
            timeTrigger.classList.add('is-placeholder');
          }
          slotErr('date', ''); closeCal(); save();
        }
      });

      // ----- time dropdown -----
      // Per-weekday slot filtering, same feature as blood-slot-booking:
      // each daySlots[weekday] is a comma list of allowed slot keys (empty = all allowed).
      var DAY_SLOTS = S.daySlots || {};
      function allowedTimesFor(iso) {
        var all = S.slotTimes || [];
        if (!iso) return all;
        var dt = new Date(iso + 'T00:00:00');
        if (isNaN(dt.getTime())) return all;
        var cfg = DAY_SLOTS[String(dt.getDay())];
        if (!cfg || typeof cfg !== 'string' || !cfg.trim()) return all;
        var keys = cfg.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (!keys.length) return all;
        return all.filter(function (t) { return keys.indexOf(t.key) !== -1; });
      }
      function buildTimes() {
        var times = allowedTimesFor(state.slot.date);
        timeList.innerHTML = times.map(function (t) {
          return '<div class="bvb-timelist__opt' + (state.slot.time === t.label ? ' is-selected' : '') + '" role="option" data-time="' + t.label.replace(/"/g, '&quot;') + '">' + t.label + '</div>';
        }).join('');
      }
      function openTime() { buildTimes(); timeList.hidden = false; timeTrigger.setAttribute('aria-expanded', 'true'); closeCal(); scrollPickerIntoView(timeList); }
      function closeTime() { timeList.hidden = true; timeTrigger.setAttribute('aria-expanded', 'false'); clearPickerSpacer(); }
      timeTrigger.addEventListener('click', function (e) { e.stopPropagation(); timeList.hidden ? openTime() : closeTime(); });
      timeList.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-time]'); if (!opt) return;
        var t = opt.getAttribute('data-time');
        state.slot.time = t; timeHidden.value = t; timeText.textContent = t;
        state.bookingConfirmed = false; // slot changed → must re-confirm
        timeTrigger.classList.remove('is-placeholder');
        slotErr('time', ''); closeTime(); save();
      });

      // ----- state dropdown (custom, mirrors the time dropdown) -----
      function openState() { if (!stateList) return; stateList.hidden = false; stateTrigger.setAttribute('aria-expanded', 'true'); closeCal(); closeTime(); }
      function closeState() { if (!stateList) return; stateList.hidden = true; stateTrigger.setAttribute('aria-expanded', 'false'); }
      function selectState(val) {
        state.slot.state = val || '';
        if (stateHidden) stateHidden.value = val || '';
        if (stateText) stateText.textContent = val || 'Select';
        if (stateTrigger) stateTrigger.classList.toggle('is-placeholder', !val);
        if (stateList) Array.prototype.forEach.call(stateList.querySelectorAll('[data-state]'), function (o) {
          o.classList.toggle('is-selected', o.getAttribute('data-state') === val);
        });
        state.bookingConfirmed = false; // slot changed → must re-confirm
        slotErr('state', ''); save();
      }
      if (stateTrigger && stateList) {
        stateTrigger.addEventListener('click', function (e) { e.stopPropagation(); stateList.hidden ? openState() : closeState(); });
        stateList.addEventListener('click', function (e) {
          var opt = e.target.closest('[data-state]'); if (!opt) return;
          selectState(opt.getAttribute('data-state')); closeState();
        });
      }

      // close pickers on outside click
      document.addEventListener('click', function (e) {
        if (!slotEl.contains(e.target)) { closeCal(); closeTime(); closeState(); }
        else {
          if (cal && !cal.hidden && !e.target.closest('[data-bvb-cal]') && !e.target.closest('[data-bvb-date-trigger]')) closeCal();
          if (timeList && !timeList.hidden && !e.target.closest('[data-bvb-timelist]') && !e.target.closest('[data-bvb-time-trigger]')) closeTime();
          if (stateList && !stateList.hidden && !e.target.closest('[data-bvb-statelist]') && !e.target.closest('[data-bvb-state-trigger]')) closeState();
        }
      });

      // ----- reschedule lock: only date / time / reason are editable -----
      // Anything else is intercepted (capture phase, before field handlers) and the
      // "address can't be changed" explainer is shown instead.
      var mAddrLockGuard = root.querySelector('[data-bvb-modal="reschedule-lock"]');
      function rescheduleEditable(t) {
        // Only date, time and reason are editable while rescheduling. Everything else — including
        // email — is locked: the booking's contact details carry over unchanged, so interacting
        // with them raises the "can't be changed" explainer.
        return !!(t.closest('[data-bvb-date-trigger]') || t.closest('[data-bvb-cal]') ||
                  t.closest('[data-bvb-time-trigger]') || t.closest('[data-bvb-timelist]') ||
                  t.closest('[data-bvb-reschedule-reason]'));
      }
      function rescheduleLockedControl(t) {
        if (rescheduleEditable(t)) return null;
        return t.closest('input:not([type=hidden]), textarea, select, [data-bvb-state-trigger], [data-bvb-address]');
      }
      function rescheduleGuard(e) {
        if (!state.isReschedule) return;
        if (!rescheduleLockedControl(e.target)) return;
        e.preventDefault();
        e.stopPropagation();
        if (mAddrLockGuard && mAddrLockGuard.classList.contains('is-open')) return;
        var t = e.target;
        if (t && t.blur) try { t.blur(); } catch (err) {}
        openModal(mAddrLockGuard);
      }
      // NB: no 'focusin' here — entering reschedule auto-focuses the first field (the address
      // input, via showStep), which would pop this modal on load. Only react to real user intent:
      // a pointer interaction (mousedown/click) or a keystroke aimed at a locked control.
      ['mousedown', 'click', 'keydown'].forEach(function (ev) {
        slotEl.addEventListener(ev, rescheduleGuard, true);
      });

      // ----- address search + map modal (Google Maps Places) -----
      initAddress();
      function initAddress() {
        var addrInput = slotEl.querySelector('[data-bvb-address]');
        var acWrap = slotEl.querySelector('[data-bvb-autocomplete]');
        var modal = root.querySelector('[data-bvb-modal="location"]');
        if (!addrInput || !modal) return;

        var searchInput = modal.querySelector('[data-bvb-loc-search]');
        var mapEl = modal.querySelector('[data-bvb-loc-map]');
        var useBtn = modal.querySelector('[data-bvb-loc-usecurrent]');
        var useTxt = modal.querySelector('[data-bvb-loc-usecurrent-text]');
        var rowEl = modal.querySelector('[data-bvb-loc-row]');
        var nameEl = modal.querySelector('[data-bvb-loc-name]');
        var addrEl = modal.querySelector('[data-bvb-loc-address]');
        var phEl = modal.querySelector('[data-bvb-loc-placeholder]');
        var titleEl = modal.querySelector('[data-bvb-loc-title]');
        var confirmBtn = modal.querySelector('[data-bvb-loc-confirm]');

        var cityInput = slotEl.querySelector('[data-slot="city"]');
        var pinInput = slotEl.querySelector('[data-slot="pincode"]');

        var apiKey = S.placesApiKey || '';
        var map = null, marker = null, geocoder = null, autocomplete = null, mapsReady = false, geoTimer = null;
        var acService = null, placesService = null, dropdown = null, acDebounce = null, suppress = false;
        var selected = { address: '', name: '', city: '', pincode: '', state: '' };
        var PIN = { path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z', fillColor: '#000', fillOpacity: 1, strokeWeight: 0, scale: 1.6 };
        var LOC_SVG =
          '<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M11.7339 2.0498C14.923 2.0498 17.5081 4.63514 17.5083 7.82422V7.8252C17.5101 8.76993 17.2787 9.70139 16.8345 10.5352C16.6591 10.8643 16.452 11.1753 16.2163 11.4648C16.1914 11.4954 16.1663 11.5256 16.1411 11.5557L16.1362 11.5625L16.0327 11.6836L12.4116 15.5293C12.3246 15.6217 12.2196 15.6958 12.103 15.7461C11.9865 15.7964 11.8608 15.8223 11.7339 15.8223C11.607 15.8222 11.4813 15.7964 11.3647 15.7461C11.2482 15.6958 11.1432 15.6217 11.0562 15.5293L7.60205 11.8623L7.3208 11.5488L7.31787 11.5449L7.15771 11.3467C6.38046 10.3402 5.95723 9.10166 5.95947 7.8252V7.82422C5.95965 4.63525 8.54492 2.04999 11.7339 2.0498ZM11.7358 5.2168C10.9949 5.21686 10.2842 5.51122 9.76025 6.03516C9.23642 6.55913 8.94189 7.26982 8.94189 8.01074C8.94197 8.75168 9.23633 9.4624 9.76025 9.98633C10.2842 10.5103 10.9949 10.8046 11.7358 10.8047C12.4768 10.8047 13.1875 10.5102 13.7114 9.98633C14.2354 9.4624 14.5297 8.75168 14.5298 8.01074C14.5298 7.26971 14.2354 6.55915 13.7114 6.03516C13.1874 5.51116 12.4769 5.2168 11.7358 5.2168Z" stroke="black" stroke-width="1.11765"/>' +
          '</svg>';

        function loadMaps(cb) {
          if (window.google && google.maps && google.maps.places) { cb(); return; }
          if (!apiKey) { cb(); return; }
          var existing = document.querySelector('script[data-bvb-places]');
          if (existing) { existing.addEventListener('load', cb); return; }
          var s = document.createElement('script');
          s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&libraries=places';
          s.async = true; s.defer = true; s.setAttribute('data-bvb-places', '1'); s.onload = cb;
          document.head.appendChild(s);
        }

        function pickComponents(components) {
          var out = { city: '', state: '', pincode: '', name: '' };
          var locality = '', district = '', sublocality = '';
          (components || []).forEach(function (c) {
            var t = c.types || [];
            if (t.indexOf('locality') !== -1) locality = locality || (c.long_name || c.short_name || '');
            if (t.indexOf('postal_town') !== -1) locality = locality || (c.long_name || c.short_name || '');
            if (t.indexOf('administrative_area_level_2') !== -1) district = district || (c.long_name || c.short_name || '');
            if (t.indexOf('sublocality_level_1') !== -1 || t.indexOf('sublocality') !== -1) sublocality = sublocality || (c.long_name || c.short_name || '');
            if (t.indexOf('administrative_area_level_1') !== -1) out.state = c.long_name || c.short_name || '';
            if (t.indexOf('postal_code') !== -1) out.pincode = c.long_name || c.short_name || '';
          });
          out.city = (locality || district || sublocality || '').trim();
          out.name = sublocality || locality || district || '';
          return out;
        }

        // write address (+ optional components) back into the bvb slot fields
        function applyAddress(address, comps) {
          state.bookingConfirmed = false; // slot changed → must re-confirm
          if (address != null) { state.slot.address = address; addrInput.value = address; slotErr('address', ''); }
          if (comps) {
            if (comps.city) { state.slot.city = comps.city; if (cityInput) { cityInput.value = comps.city; slotErr('city', ''); } }
            if (comps.pincode) { state.slot.pincode = comps.pincode; if (pinInput) { pinInput.value = comps.pincode; slotErr('pincode', ''); } }
            if (comps.state && stateList) {
              var want = comps.state.toLowerCase(), matched = '';
              Array.prototype.forEach.call(stateList.querySelectorAll('[data-state]'), function (o) {
                var ov = o.getAttribute('data-state'); if (!matched && ov && ov.toLowerCase() === want) matched = ov;
              });
              if (matched) selectState(matched);
            }
          }
          save();
        }

        /* ---------- address typeahead dropdown ---------- */
        function ensureDropdown() {
          if (dropdown) return dropdown;
          dropdown = document.createElement('div');
          dropdown.className = 'bvb-autocomplete__list';
          dropdown.setAttribute('role', 'listbox');
          dropdown.style.display = 'none';
          (acWrap || addrInput.parentNode).appendChild(dropdown);
          return dropdown;
        }
        function clearDropdown() { if (dropdown) { dropdown.innerHTML = ''; dropdown.style.display = 'none'; } }
        function locationRow() {
          var item = document.createElement('div');
          item.className = 'bvb-autocomplete__item bvb-autocomplete__item--location';
          item.setAttribute('role', 'option');
          item.innerHTML = LOC_SVG + '<span>Use current location</span>';
          item.addEventListener('mousedown', function (e) { e.preventDefault(); openMapModal(); });
          return item;
        }
        function showLocationOnly() {
          if (suppress) return;
          var dd = ensureDropdown(); dd.innerHTML = ''; dd.appendChild(locationRow()); dd.style.display = 'block';
        }
        function renderPredictions(preds) {
          if (suppress) return;
          var dd = ensureDropdown(); dd.innerHTML = '';
          dd.appendChild(locationRow());
          (preds || []).forEach(function (p) {
            var item = document.createElement('div');
            item.className = 'bvb-autocomplete__item';
            item.setAttribute('role', 'option');
            item.textContent = p.description || '';
            item.addEventListener('mousedown', function (e) { e.preventDefault(); selectPrediction(p); });
            dd.appendChild(item);
          });
          dd.style.display = 'block';
        }
        function selectPrediction(p) {
          if (!p) return;
          suppress = true; clearDropdown();
          applyAddress(p.description || '', null);
          setTimeout(function () { suppress = false; }, 400);
          if (!p.place_id || !placesService) return;
          placesService.getDetails({ placeId: p.place_id, fields: ['address_component'] }, function (place, status) {
            if (!place || !place.address_components || !window.google || !google.maps.places || status !== google.maps.places.PlacesServiceStatus.OK) return;
            applyAddress(null, pickComponents(place.address_components));
          });
        }
        function fetchPredictions(q) {
          if (!acService || !q || q.length < 3) { clearDropdown(); return; }
          acService.getPlacePredictions({ input: q, componentRestrictions: { country: 'in' }, types: ['geocode'] }, function (preds, status) {
            if (!window.google || !google.maps.places || status !== google.maps.places.PlacesServiceStatus.OK) { clearDropdown(); return; }
            if (suppress) return;
            renderPredictions(preds || []);
          });
        }
        function ensureServices() {
          if (acService || !window.google || !google.maps || !google.maps.places) return;
          acService = new google.maps.places.AutocompleteService();
          placesService = new google.maps.places.PlacesService(document.createElement('div'));
        }
        function refreshDropdown() {
          loadMaps(function () {
            ensureServices();
            var v = (addrInput.value || '').trim();
            if (v.length >= 3) fetchPredictions(v); else showLocationOnly();
          });
        }
        // Open on real user interaction (click) — not on the browser restoring
        // focus to this field after a page reload, which would pop the dropdown unprompted.
        addrInput.addEventListener('mousedown', function () { if (!suppress) refreshDropdown(); });
        addrInput.addEventListener('input', function () {
          if (acDebounce) clearTimeout(acDebounce);
          acDebounce = setTimeout(function () { if (!suppress) refreshDropdown(); }, 200);
        });
        addrInput.addEventListener('blur', function () { setTimeout(clearDropdown, 150); });

        /* ---------- map modal ("Use current location") ---------- */
        function setSelected(address, comps) {
          selected.address = address || '';
          if (comps) { selected.city = comps.city; selected.state = comps.state; selected.pincode = comps.pincode; selected.name = comps.name; }
          var has = !!(selected.address && selected.address.trim());
          if (titleEl) titleEl.textContent = has ? 'Selected Location' : 'Select a Location';
          if (phEl) phEl.style.display = has ? 'none' : 'block';
          if (rowEl) rowEl.style.display = has ? 'flex' : 'none';
          if (nameEl) nameEl.textContent = selected.name || (selected.address.split(',')[0] || '');
          if (addrEl) { addrEl.textContent = selected.address; addrEl.style.display = has ? 'block' : 'none'; }
          if (confirmBtn) confirmBtn.disabled = !has;
        }

        function reverseGeocode(latLng) {
          if (!geocoder) return;
          geocoder.geocode({ location: latLng }, function (results) {
            if (!results || !results.length) { setSelected('', null); return; }
            setSelected(results[0].formatted_address || '', pickComponents(results[0].address_components));
          });
        }

        function placeMarker(latLng) {
          if (!map) return;
          if (marker) marker.setMap(null);
          marker = new google.maps.Marker({ position: latLng, map: map, draggable: true, icon: PIN });
          marker.addListener('dragend', function () {
            if (geoTimer) clearTimeout(geoTimer);
            geoTimer = setTimeout(function () { reverseGeocode(marker.getPosition()); }, 300);
          });
          reverseGeocode(latLng);
        }

        function ensureMap() {
          if (mapsReady || !window.google || !google.maps) return;
          mapsReady = true;
          geocoder = new google.maps.Geocoder();
          map = new google.maps.Map(mapEl, { center: { lat: 20.5937, lng: 78.9629 }, zoom: 5, disableDefaultUI: true, gestureHandling: 'greedy', clickableIcons: false });
          map.addListener('click', function (e) { placeMarker(e.latLng); });
          if (google.maps.places && google.maps.places.Autocomplete && searchInput) {
            autocomplete = new google.maps.places.Autocomplete(searchInput, { fields: ['geometry', 'formatted_address', 'address_components'], componentRestrictions: { country: 'in' } });
            autocomplete.addListener('place_changed', function () {
              var p = autocomplete.getPlace();
              if (!p || !p.geometry || !p.geometry.location) return;
              map.setCenter(p.geometry.location); map.setZoom(15);
              placeMarker(p.geometry.location);
              setSelected(p.formatted_address || '', pickComponents(p.address_components));
            });
          }
        }

        function openMapModal() {
          clearDropdown();
          if (modal.classList.contains('is-open')) return;
          setSelected(selected.address || '', null);
          openModal(modal);
          loadMaps(function () { ensureMap(); if (map) try { google.maps.event.trigger(map, 'resize'); } catch (e) {} });
        }

        modal.addEventListener('click', function (e) {
          if (e.target.closest('[data-bvb-modal-close]') || e.target.closest('.bvb-modal__overlay')) closeModal(modal);
        });

        if (useBtn) {
          useBtn.addEventListener('click', function () {
            if (!navigator.geolocation) return;
            useBtn.disabled = true; if (useTxt) useTxt.textContent = 'Getting location…';
            navigator.geolocation.getCurrentPosition(function (pos) {
              useBtn.disabled = false; if (useTxt) useTxt.textContent = 'Use current location';
              var ll = { lat: pos.coords.latitude, lng: pos.coords.longitude };
              if (map) { map.setCenter(ll); map.setZoom(15); placeMarker(ll); }
            }, function () { useBtn.disabled = false; if (useTxt) useTxt.textContent = 'Use current location'; }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 });
          });
        }

        if (confirmBtn) {
          confirmBtn.addEventListener('click', function () {
            if (!selected.address) return;
            applyAddress(selected.address, { city: selected.city, pincode: selected.pincode, state: selected.state });
            closeModal(modal);
          });
        }
      }
    }

    function hydrateSlot() {
      if (!slotEl) return;
      Array.prototype.forEach.call(slotEl.querySelectorAll('[data-slot]'), function (inp) {
        var key = inp.getAttribute('data-slot');
        var v = state.slot[key];
        if (v == null) return;
        inp.value = v;
        if (key === 'date' && v) {
          var t = slotEl.querySelector('[data-bvb-date-text]'); if (t) { t.textContent = v.split('-').reverse().join('-'); slotEl.querySelector('[data-bvb-date-trigger]').classList.remove('is-placeholder'); }
        }
        if (key === 'time' && v) {
          var tt = slotEl.querySelector('[data-bvb-time-text]'); if (tt) { tt.textContent = v; slotEl.querySelector('[data-bvb-time-trigger]').classList.remove('is-placeholder'); }
        }
        if (key === 'state' && v) {
          var stt = slotEl.querySelector('[data-bvb-state-text]');
          if (stt) { stt.textContent = v; slotEl.querySelector('[data-bvb-state-trigger]').classList.remove('is-placeholder'); }
          var sl = slotEl.querySelector('[data-bvb-statelist]');
          if (sl) Array.prototype.forEach.call(sl.querySelectorAll('[data-state]'), function (o) { o.classList.toggle('is-selected', o.getAttribute('data-state') === v); });
        }
      });
    }

    function validateSlot() {
      if (!slotEl) return true;
      var ok = true;
      var checks = [
        ['address', state.slot.address, 'Please enter your address'],
        ['flat', state.slot.flat, 'Please enter your flat / house no.'],
        ['landmark', state.slot.landmark, 'Please enter a nearby landmark'],
        ['email', state.slot.email, 'Please enter your email'],
        ['city', state.slot.city, 'Please enter your city'],
        ['pincode', state.slot.pincode, 'Please enter a valid 6-digit pincode'],
        ['state', state.slot.state, 'Select an option'],
        ['date', state.slot.date, 'Please select a date'],
        ['time', state.slot.time, 'Please select a time']
      ];
      // Reason is mandatory only when rescheduling an existing booking.
      if (state.isReschedule) {
        checks.push(['reschedule_reason', state.slot.reschedule_reason, 'Please enter a reason for reschedule']);
      }
      checks.forEach(function (c) {
        var key = c[0], val = (c[1] || '').toString().trim(), msg = c[2];
        var bad = !val;
        if (!bad && key === 'pincode' && !/^[1-9][0-9]{5}$/.test(val)) bad = true;
        if (!bad && key === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { bad = true; msg = 'Please enter a valid email'; }
        if (bad) { ok = false; slotEl.__slotErr(key, msg); } else { slotEl.__slotErr(key, ''); }
      });
      // Block & surface the modal if the pincode isn't serviceable.
      if (ok && slotEl.__checkPincode && !slotEl.__checkPincode()) ok = false;
      return ok;
    }

    /* ---------- boot ---------- */
    logStorage('boot:' + journey);
    setUploadView('empty');
    if (state.isReschedule && slotEl) {
      slotEl.classList.add('is-reschedule');          // reveal "Reason for reschedule"
      var savedR = loadSaved();
      if (savedR && savedR.slot) { state.slot = savedR.slot; hydrateSlot(); } // prefill prior details if present
      showStep(0, true);
      // The customerId arrives in the URL, so fetch its journey and fill the slot form with the
      // booked details (address, date/time, etc.). Falls back to whatever local progress exists.
      prefillRescheduleFromServer();
      return;
    }
    checkPaidJourney(); // background: if the stored journey is paid, switch to the confirmation screen
    var saved = loadSaved();
    if (saved && (saved.step > 0 || (saved.answers && Object.keys(saved.answers).length))) {
      // On this page a reload should keep the user in the same journey — resume silently,
      // no "continue vs new" prompt (that choice lives on the landing page).
      applyResume();
      return;
    }
    showStep(0, true);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bvb]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
